RivalIQ.apps.Overview.module('data', function (data, App, Backbone, Marionette, $, _) {

    const OBSERVATION_METRICS = data.OBSERVATION_METRICS = {
        FocusCompanyMainPeriod: 'FocusCompanyMainPeriod',
        FocusCompanyComparePeriod: 'FocusCompanyComparePeriod',
        FocusCompanyPercentChange: 'FocusCompanyPercentChange',
        FocusCompanyPercentChangeByChannel: 'FocusCompanyPercentChangeByChannel',
        FocusCompanyPercentChangeNumPosts: 'FocusCompanyPercentChangeNumPosts',
        FocusCompanyMainPeriodEngTotalPerPost: 'FocusCompanyMainPeriodEngTotalPerPost',
        FocusCompanyComparePeriodNumPosts: 'FocusCompanyComparePeriodNumPosts',
        FocusCompanyComparePeriodEngTotal: 'FocusCompanyComparePeriodEngTotal',
        FocusCompanyMainPeriodBestPost: 'FocusCompanyMainPeriodBestPost',
        FocusCompanyComparePeriodBestPost: 'FocusCompanyComparePeriodBestPost',
        FocusCompanyPostsPerDay: 'FocusCompanyPostsPerDay',
        FocusCompanyComparePeriodPostsPerDay: 'FocusCompanyComparePeriodPostsPerDay',
        FocusCompanyAbsoluteChange: 'FocusCompanyAbsoluteChange',
        FocusCompanyAbsoluteChangeByChannel: 'FocusCompanyAbsoluteChangeByChannel',
        FocusCompanyMainPeriodTweetsByType: 'FocusCompanyMainPeriodTweetsByType',

        ByCompany: 'ByCompany',

        BenchmarkAverage: 'BenchmarkAverage',
        BenchmarkAveragePercentChanged: 'BenchmarkAveragePercentChanged',
        BenchmarkAveragePostsPerDay: 'BenchmarkAveragePostsPerDay',
        BenchmarkAverageAbsoluteChange: 'BenchmarkAverageAbsoluteChange',
        BenchmarkAverageAbsoluteChangeByChannel: 'BenchmarkAverageAbsoluteChangeByChannel',
        BenchmarkAverageMainPeriodTweetsByType: 'BenchmarkAverageMainPeriodTweetsByType'
    };

    const POSTS_PER_DAY_RECS = {
        facebook: [0.7, 2],
        instagram: [0.6, 2],
        twitter: [0.8, 3]
    };

    data._ActivityRecommendationTooltipContent = $('#landscapeComparisonActivityRecommendationTemplate').html();

    const SingleChannelCompetitiveMetrics = ['audience', 'presence_reach', 'engagement_total', 'avg_engagement_rate_per_post', 'engagement_total_per_view', 'views'];
    const SingleChannelCountMetrics = ['count', 'all_count', 'avg_count_per_week', 'all_avg_count_per_week'];
    const SingleChannelPercentChangedMetrics = ['audience', 'presence_reach', 'engagement_total', 'avg_engagement_rate_per_post', 'views', 'engagement_total_per_view'];

    const CrossChannelCompetitiveMetrics = ['audience', 'engagement_total'];
    const CrossChannelActivityMetrics = ['count', 'avg_count_per_week'];
    const CrossChanneChangeMetrics = ['audience', 'engagement_total'];

    // careful changing these, some text strings rely on these values resulting in things that round to be > 1.
    const ABOVE_VALUE_THRESHOLD = 1.5;

    const RANGE_COMPARE_LARGE_NUMBER_THRESHOLD = 500;
    const ABOVE_RANGE_THRESHOLD = 1.1;
    const BELOW_RANGE_THRESHOLD = 0.9;

    const SMALL_NUMBERS_ABOVE_RANGE_THRESHOLD = 1.05;
    const SMALL_NUMBERS_BELOW_RANGE_THRESHOLD = 0.95;

    const ABOVE_RANGE = 'ABOVE_RANGE';
    const NEAR_RANGE = 'NEAR_RANGE';
    const BELOW_RANGE = 'BELOW_RANGE';


    function relationToRange(value, referenceRange) {

        if (!_.isFinite(value)) {
            return;
        }

        const rangeHighEnd = (_.isArray(referenceRange) ? referenceRange[1] : referenceRange);
        const rangeLowEnd = (_.isArray(referenceRange) ? referenceRange[0] : referenceRange);

        let referenceHighEnd;
        let referenceLowEnd;

        if (value >= RANGE_COMPARE_LARGE_NUMBER_THRESHOLD) {
            referenceHighEnd = rangeHighEnd * ABOVE_RANGE_THRESHOLD;
            referenceLowEnd = rangeLowEnd * BELOW_RANGE_THRESHOLD;
        } else {
            referenceHighEnd = rangeHighEnd * SMALL_NUMBERS_ABOVE_RANGE_THRESHOLD;
            referenceLowEnd = rangeLowEnd * SMALL_NUMBERS_BELOW_RANGE_THRESHOLD;
        }

        if (value > referenceHighEnd) {
            return ABOVE_RANGE;
        }

        if (value <= referenceLowEnd) {
            return BELOW_RANGE;
        }

        return NEAR_RANGE;
    }

    function getSingleChannel(props) {
        if (props.channel) {
            return props.channel;
        }

        const channels = RivalIQ.data.channels.inCrossChannel().forAnalyze().withAccess().notHidden(true);

        if (channels.length === 1) {
            return channels.at(0).getChannel();
        }
    }

    function isSingleChannel(props) {
        return Boolean(getSingleChannel(props));
    }

    function companyLink(company, possessive) {

        let companyName = (company ? _.trim(company.get('name')) : '');
        if (possessive) {
            companyName = App.utils.makePossessive(companyName);
        }

        return $.tagHtml('a', {
            class: 'company-link',
            text: companyName,
            href: `/company/${company.id}`
        });
    }

    function otherCompanyLink(compareAgainst, dashboardModel, possessive, landscapeAverageOverride) {
        const companies = App.utils.getCompaniesForFilter(compareAgainst.benchmarkCompaniesFilter, dashboardModel);

        if (companies.length === 1) {
            return companyLink(companies[0], possessive);
        }

        let otherCompaniesName;
        if (compareAgainst.benchmarkCompaniesFilter === RivalIQ.enums.benchmarkCompaniesFilters.all_companies.id) {
            otherCompaniesName = landscapeAverageOverride || 'the landscape average';
        } else {
            otherCompaniesName = 'your average competitor';
        }

        if (possessive) {
            otherCompaniesName = App.utils.makePossessive(otherCompaniesName);
        }
        return otherCompaniesName;
    }

    function metricName(metric) {
        if (!isSingleChannel(metric.attributes)) {
            // cross-channel
            switch (metric.get('property')) {
                case 'audience':
                    return 'Audience';

                case 'engagement_total':
                    return 'Total Engagement';

                default:
                    return metric.getName();
            }
        }

        const channel = RivalIQ.data.channels.get(getSingleChannel(metric.attributes));
        return `${channel.get('name')} ${metric.getName()}`;
    }

    function compareAgainstName(metric) {
        const compareAgainst = _.find(RivalIQ.enums.benchmarkCompareAgainstOptions, {
            benchmarkCompaniesFilter: metric.get('benchmarkCompaniesFilter'),
            aggregate: metric.get('aggregate')
        });

        return compareAgainst.name.toLowerCase();
    }

    function formatPostsPerPeriod(postsPerPeriodMetric, noPostWord) {
        let postsPerDayRaw = _.get(postsPerPeriodMetric.getValue({
            format: false
        }), [0, 0]);

        const channel = getSingleChannel(postsPerPeriodMetric.attributes);
        let postWord = 'post';
        if (channel) {
            postWord = RivalIQ.data.channels.get(channel).get('postName');
        }

        if (noPostWord) {
            postWord = '';
        }

        let isRounded;
        let postsPerWeek = postsPerDayRaw * 7;
        const timePeriod = postsPerPeriodMetric.get('timePeriod');
        const timePeriodDurationDays = moment.utc(timePeriod.mainPeriodEnd).diff(timePeriod.mainPeriodStart, 'day', true);
        if (timePeriodDurationDays > 7) {
            if (postsPerWeek < 0.8) {
                return `less than one ${postWord} per week`;
            } else {
                isRounded = (postsPerWeek !== Math.round(postsPerWeek));
                postsPerWeek = Math.round(postsPerWeek);
                postWord += (postsPerWeek === 1 || noPostWord ? '' : 's');
                return `${(isRounded ? 'about ' : '') +
                    App.utils.numToWords(postsPerWeek)} ${
                    postWord} per week`;
            }
        } else {
            if (postsPerDayRaw < 0.4) {
                return `one ${postWord} every few days`;
            } else if (postsPerDayRaw < 0.6) {
                return `one ${postWord} every other day`;
            } else if (postsPerDayRaw < 1.2) {
                return `${postsPerDayRaw === 1 ? '' : 'about '}one ${postWord} per day`;
            } else if (postsPerDayRaw < 1.7) {
                if (!noPostWord) {
                    postWord += 's';
                }
                return `one or two ${postWord} per day`;
            } else {
                isRounded = (postsPerDayRaw !== Math.round(postsPerDayRaw));
                postsPerDayRaw = Math.round(postsPerDayRaw);
                postWord += (postsPerDayRaw === 1 || noPostWord ? '' : 's');
                return `${(isRounded ? 'about ' : '') +
                    App.utils.numToWords(postsPerDayRaw)} ${
                    postWord} per day`;
            }
        }
    }

    function getSingleMetricValue(observationMetrics, key) {
        const metric = observationMetrics[key];
        return _.get(metric.getValue({
            format: false
        }), [0, 0]);
    }

    function getDataByFreeDimension(observationMetrics, metricKey) {
        const byFreeDimension = observationMetrics[metricKey];
        let dataByFreeDimension = _.filter(byFreeDimension.getValue({
            format: false
        }), function (value) {
            return _.isFinite(_.last(value)); // filter out dimensions values without data (e.g., companies without data)
        });

        dataByFreeDimension = _.orderBy(dataByFreeDimension, [_.last], ['desc']);

        return dataByFreeDimension;
    }

    data.getMetricsToLoad = function (dashboardModel, metric) {
        const metricsToLoad = [];

        const metricIdxToKey = [];
        const selectedBenchmarkCompareAgainst = App.utils.getSelectedBenchmarkCompareAgainst();

        const props = dashboardModel.getProps();

        let mappedActivityProperty = metric.property;
        if (mappedActivityProperty === 'avg_count_per_week') {
            mappedActivityProperty = 'count';
        } else if (mappedActivityProperty === 'all_avg_count_per_week') {
            mappedActivityProperty = 'all_count';
        }

        if (isSingleChannel(props)) {

            const channel = getSingleChannel(props);

            // Single Channel 1a
            if (_.includes(SingleChannelCompetitiveMetrics, metric.property)) {
                metricIdxToKey.push(OBSERVATION_METRICS.FocusCompanyMainPeriod);
                metricsToLoad.push(_.defaults({
                    dimensions: ['timeAnalysisMode', 'channel', 'companyId'],
                    property: metric.property,
                    companyId: props.focusCompanyId,
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
                    channel: channel
                }, props, metric));

                metricIdxToKey.push(OBSERVATION_METRICS.FocusCompanyComparePeriod);
                metricsToLoad.push(_.defaults({
                    dimensions: ['timeAnalysisMode', 'channel', 'companyId'],
                    property: metric.property,
                    companyId: props.focusCompanyId,
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.COMPARE_PERIOD,
                    channel: channel
                }, props, metric));

                metricIdxToKey.push(OBSERVATION_METRICS.ByCompany);
                metricsToLoad.push(_.defaults({
                    dimensions: ['timeAnalysisMode', 'channel', 'companyId'],
                    property: metric.property,
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
                    channel: channel
                }, props, metric));

                metricIdxToKey.push(OBSERVATION_METRICS.BenchmarkAverage);
                metricsToLoad.push(_.defaults({
                    dimensions: ['timeAnalysisMode', 'channel'],
                    property: metric.property,
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
                    channel: channel,
                    benchmarkCompaniesFilter: selectedBenchmarkCompareAgainst.benchmarkCompaniesFilter,
                    aggregate: selectedBenchmarkCompareAgainst.aggregate
                }, props, metric));

                metricIdxToKey.push(OBSERVATION_METRICS.FocusCompanyPostsPerDay);
                metricsToLoad.push(_.defaults({
                    dimensions: ['timeAnalysisMode', 'channel', 'companyId'],
                    property: 'all_avg_count_per_day',
                    companyId: props.focusCompanyId,
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
                    channel: channel
                }, props, metric));

                metricIdxToKey.push(OBSERVATION_METRICS.BenchmarkAveragePostsPerDay);
                metricsToLoad.push(_.defaults({
                    dimensions: ['timeAnalysisMode', 'channel'],
                    property: 'all_avg_count_per_day',
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
                    channel: channel,
                    benchmarkCompaniesFilter: selectedBenchmarkCompareAgainst.benchmarkCompaniesFilter,
                    aggregate: selectedBenchmarkCompareAgainst.aggregate
                }, props, metric));
            }

            // Single Channel 1b
            if (_.includes(SingleChannelCountMetrics, metric.property)) {
                metricIdxToKey.push(OBSERVATION_METRICS.FocusCompanyMainPeriod);
                metricsToLoad.push(_.defaults({
                    dimensions: ['timeAnalysisMode', 'channel', 'companyId'],
                    property: 'count', // intentionally excluding non-normal tweets here.
                    companyId: props.focusCompanyId,
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
                    channel: channel
                }, props, metric));

                metricIdxToKey.push(OBSERVATION_METRICS.FocusCompanyPostsPerDay);
                metricsToLoad.push(_.defaults({
                    dimensions: ['timeAnalysisMode', 'channel', 'companyId'],
                    property: 'avg_count_per_day',
                    companyId: props.focusCompanyId,
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
                    channel: channel
                }, props, metric));

                metricIdxToKey.push(OBSERVATION_METRICS.BenchmarkAveragePostsPerDay);
                metricsToLoad.push(_.defaults({
                    dimensions: ['timeAnalysisMode', 'channel'],
                    property: 'avg_count_per_day',
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
                    channel: channel,
                    benchmarkCompaniesFilter: selectedBenchmarkCompareAgainst.benchmarkCompaniesFilter,
                    aggregate: selectedBenchmarkCompareAgainst.aggregate
                }, props, metric));

                metricIdxToKey.push(OBSERVATION_METRICS.ByCompany);
                metricsToLoad.push(_.defaults({
                    dimensions: ['timeAnalysisMode', 'channel', 'companyId'],
                    property: 'avg_count_per_day',
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
                    channel: channel
                }, props, metric));
            }

            // Single Channel 1b Twitter
            if (_.includes(SingleChannelCountMetrics, metric.property) && channel === RivalIQ.enums.channels.TWITTER) {

                metricIdxToKey.push(OBSERVATION_METRICS.FocusCompanyMainPeriodTweetsByType);
                metricsToLoad.push(_.defaults({
                    dimensions: ['timeAnalysisMode', 'channel', 'companyId', 'tweetType'],
                    property: 'all_count',
                    companyId: props.focusCompanyId,
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
                    channel: channel
                }, props, metric));

                metricIdxToKey.push(OBSERVATION_METRICS.BenchmarkAverageMainPeriodTweetsByType);
                metricsToLoad.push(_.defaults({
                    dimensions: ['timeAnalysisMode', 'channel', 'tweetType'],
                    property: 'all_count',
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
                    channel: channel,
                    benchmarkCompaniesFilter: selectedBenchmarkCompareAgainst.benchmarkCompaniesFilter,
                    aggregate: selectedBenchmarkCompareAgainst.aggregate
                }, props, metric));
            }

            // Single Channel 2a
            if (_.includes(SingleChannelPercentChangedMetrics, metric.property)) {
                metricIdxToKey.push(OBSERVATION_METRICS.FocusCompanyMainPeriod);
                metricsToLoad.push(_.defaults({
                    dimensions: ['timeAnalysisMode', 'channel', 'companyId'],
                    property: metric.property,
                    companyId: props.focusCompanyId,
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
                    channel: channel
                }, props, metric));

                metricIdxToKey.push(OBSERVATION_METRICS.FocusCompanyPercentChange);
                metricsToLoad.push(_.defaults({
                    dimensions: ['timeAnalysisMode', 'channel', 'companyId'],
                    property: metric.property,
                    companyId: props.focusCompanyId,
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE,
                    channel: channel
                }, props, metric));

                metricIdxToKey.push(OBSERVATION_METRICS.BenchmarkAverage);
                metricsToLoad.push(_.defaults({
                    dimensions: ['timeAnalysisMode', 'channel'],
                    property: metric.property,
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
                    channel: channel,
                    benchmarkCompaniesFilter: selectedBenchmarkCompareAgainst.benchmarkCompaniesFilter,
                    aggregate: selectedBenchmarkCompareAgainst.aggregate
                }, props, metric));

                metricIdxToKey.push(OBSERVATION_METRICS.BenchmarkAveragePercentChanged);
                metricsToLoad.push(_.defaults({
                    dimensions: ['timeAnalysisMode', 'channel'],
                    property: metric.property,
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE,
                    channel: channel,
                    benchmarkCompaniesFilter: selectedBenchmarkCompareAgainst.benchmarkCompaniesFilter,
                    aggregate: selectedBenchmarkCompareAgainst.aggregate
                }, props, metric));

                metricIdxToKey.push(OBSERVATION_METRICS.ByCompany);
                metricsToLoad.push(_.defaults({
                    dimensions: ['timeAnalysisMode', 'channel', 'companyId'],
                    property: metric.property,
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
                    channel: channel
                }, props, metric));


                if (_.includes(['engagement_total', 'views', 'engagement_rate_per_view'], metric.property)) {
                    metricIdxToKey.push(OBSERVATION_METRICS.FocusCompanyPercentChangeNumPosts);
                    metricsToLoad.push(_.defaults({
                        dimensions: ['timeAnalysisMode', 'channel', 'companyId'],
                        property: 'count',
                        companyId: props.focusCompanyId,
                        timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE,
                        channel: channel
                    }, props, metric));

                    metricIdxToKey.push(OBSERVATION_METRICS.FocusCompanyMainPeriodEngTotalPerPost);
                    metricsToLoad.push(_.defaults({
                        dimensions: ['timeAnalysisMode', 'channel', 'companyId'],
                        property: 'engagement_total_per_post',
                        companyId: props.focusCompanyId,
                        timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
                        channel: channel
                    }, props, metric));

                    metricIdxToKey.push(OBSERVATION_METRICS.FocusCompanyComparePeriodNumPosts);
                    metricsToLoad.push(_.defaults({
                        dimensions: ['timeAnalysisMode', 'channel', 'companyId'],
                        property: 'count',
                        companyId: props.focusCompanyId,
                        timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.COMPARE_PERIOD,
                        channel: channel
                    }, props, metric));

                    metricIdxToKey.push(OBSERVATION_METRICS.FocusCompanyComparePeriodEngTotal);
                    metricsToLoad.push(_.defaults({
                        dimensions: ['timeAnalysisMode', 'channel', 'companyId'],
                        property: 'engagement_total',
                        companyId: props.focusCompanyId,
                        timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.COMPARE_PERIOD,
                        channel: channel
                    }, props, metric));

                    metricIdxToKey.push(OBSERVATION_METRICS.FocusCompanyMainPeriodBestPost);
                    metricsToLoad.push(_.defaults({
                        dimensions: ['timeAnalysisMode', 'channel', 'companyId'],
                        property: 'highest_post_engagement_total',
                        companyId: props.focusCompanyId,
                        timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
                        channel: channel
                    }, props, metric));

                    metricIdxToKey.push(OBSERVATION_METRICS.FocusCompanyComparePeriodBestPost);
                    metricsToLoad.push(_.defaults({
                        dimensions: ['timeAnalysisMode', 'channel', 'companyId'],
                        property: 'highest_post_engagement_total',
                        companyId: props.focusCompanyId,
                        timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.COMPARE_PERIOD,
                        channel: channel
                    }, props, metric));
                }
            }
        } else {

            // Cross-channel
            metricIdxToKey.push(OBSERVATION_METRICS.FocusCompanyMainPeriod);
            metricsToLoad.push(_.defaults({
                dimensions: ['timeAnalysisMode', 'companyId'],
                property: mappedActivityProperty,
                companyId: props.focusCompanyId,
                timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD
            }, props, metric));

            // Cross-channel 1a
            if (_.includes(CrossChannelCompetitiveMetrics, metric.property)) {

                metricIdxToKey.push(OBSERVATION_METRICS.FocusCompanyComparePeriod);
                metricsToLoad.push(_.defaults({
                    dimensions: ['timeAnalysisMode', 'companyId'],
                    property: metric.property,
                    companyId: props.focusCompanyId,
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.COMPARE_PERIOD
                }, props, metric));

                metricIdxToKey.push(OBSERVATION_METRICS.FocusCompanyPostsPerDay);
                metricsToLoad.push(_.defaults({
                    dimensions: ['timeAnalysisMode', 'companyId'],
                    property: 'avg_count_per_day',
                    companyId: props.focusCompanyId,
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.COMPARE_PERIOD
                }, props, metric));

                metricIdxToKey.push(OBSERVATION_METRICS.ByCompany);
                metricsToLoad.push(_.defaults({
                    dimensions: ['timeAnalysisMode', 'companyId'],
                    property: metric.property,
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD
                }, props, metric));

                metricIdxToKey.push(OBSERVATION_METRICS.BenchmarkAverage);
                metricsToLoad.push(_.defaults({
                    dimensions: ['timeAnalysisMode'],
                    property: metric.property,
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
                    benchmarkCompaniesFilter: selectedBenchmarkCompareAgainst.benchmarkCompaniesFilter,
                    aggregate: selectedBenchmarkCompareAgainst.aggregate
                }, props, metric));
            }

            // Cross-channel 1b
            if (_.includes(CrossChannelActivityMetrics, metric.property)) {
                metricIdxToKey.push(OBSERVATION_METRICS.FocusCompanyComparePeriod);
                metricsToLoad.push(_.defaults({
                    dimensions: ['timeAnalysisMode', 'companyId'],
                    property: mappedActivityProperty,
                    companyId: props.focusCompanyId,
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.COMPARE_PERIOD
                }, props, metric));

                metricIdxToKey.push(OBSERVATION_METRICS.ByCompany);
                metricsToLoad.push(_.defaults({
                    dimensions: ['timeAnalysisMode', 'companyId'],
                    property: mappedActivityProperty,
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD
                }, props, metric));

                metricIdxToKey.push(OBSERVATION_METRICS.FocusCompanyPostsPerDay);
                metricsToLoad.push(_.defaults({
                    dimensions: ['timeAnalysisMode', 'companyId'],
                    property: 'avg_count_per_day',
                    companyId: props.focusCompanyId,
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD
                }, props, metric));

                metricIdxToKey.push(OBSERVATION_METRICS.FocusCompanyComparePeriodPostsPerDay);
                metricsToLoad.push(_.defaults({
                    dimensions: ['timeAnalysisMode', 'companyId'],
                    property: 'avg_count_per_day',
                    companyId: props.focusCompanyId,
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.COMPARE_PERIOD
                }, props, metric));

                metricIdxToKey.push(OBSERVATION_METRICS.BenchmarkAveragePostsPerDay);
                metricsToLoad.push(_.defaults({
                    dimensions: ['timeAnalysisMode'],
                    property: 'avg_count_per_day',
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
                    benchmarkCompaniesFilter: selectedBenchmarkCompareAgainst.benchmarkCompaniesFilter,
                    aggregate: selectedBenchmarkCompareAgainst.aggregate
                }, props, metric));
            }

            // Cross-channel 2a
            if (_.includes(CrossChanneChangeMetrics, metric.property)) {

                metricIdxToKey.push(OBSERVATION_METRICS.FocusCompanyAbsoluteChange);
                metricsToLoad.push(_.defaults({
                    dimensions: ['timeAnalysisMode', 'companyId'],
                    property: metric.property,
                    companyId: props.focusCompanyId,
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_ABSOLUTE
                }, props, metric));

                metricIdxToKey.push(OBSERVATION_METRICS.FocusCompanyPercentChange);
                metricsToLoad.push(_.defaults({
                    dimensions: ['timeAnalysisMode', 'companyId'],
                    property: metric.property,
                    companyId: props.focusCompanyId,
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE
                }, props, metric));

                metricIdxToKey.push(OBSERVATION_METRICS.FocusCompanyPercentChangeByChannel);
                metricsToLoad.push(_.defaults({
                    dimensions: ['timeAnalysisMode', 'companyId', 'channel'],
                    property: metric.property,
                    companyId: props.focusCompanyId,
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE
                }, props, metric));

                metricIdxToKey.push(OBSERVATION_METRICS.FocusCompanyAbsoluteChangeByChannel);
                metricsToLoad.push(_.defaults({
                    dimensions: ['timeAnalysisMode', 'companyId', 'channel'],
                    property: metric.property,
                    companyId: props.focusCompanyId,
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_ABSOLUTE
                }, props, metric));

                metricIdxToKey.push(OBSERVATION_METRICS.BenchmarkAverageAbsoluteChange);
                metricsToLoad.push(_.defaults({
                    dimensions: ['timeAnalysisMode'],
                    property: metric.property,
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_ABSOLUTE,
                    benchmarkCompaniesFilter: selectedBenchmarkCompareAgainst.benchmarkCompaniesFilter,
                    aggregate: selectedBenchmarkCompareAgainst.aggregate
                }, props, metric));

                metricIdxToKey.push(OBSERVATION_METRICS.BenchmarkAverageAbsoluteChangeByChannel);
                metricsToLoad.push(_.defaults({
                    dimensions: ['timeAnalysisMode', 'channel'],
                    property: metric.property,
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_ABSOLUTE,
                    benchmarkCompaniesFilter: selectedBenchmarkCompareAgainst.benchmarkCompaniesFilter,
                    aggregate: selectedBenchmarkCompareAgainst.aggregate
                }, props, metric));

                metricIdxToKey.push(OBSERVATION_METRICS.ByCompany);
                metricsToLoad.push(_.defaults({
                    dimensions: ['timeAnalysisMode', 'companyId'],
                    property: metric.property,
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD
                }, props, metric));
            }
        }

        return new RivalIQ.collections.MetricDefinitions(metricsToLoad).fetch()
            .then(function (results) {
                return _.reduce(metricIdxToKey, function (memo, key, idx) {
                    memo[key] = results.at(idx);
                    return memo;
                }, {});
            });
    };

    data._generateSingleChannelMissingObservation = function (dashboardModel, observationMetrics) {

        if (!isSingleChannel(dashboardModel.getProps())) {
            // cross-channel
            return;
        }

        const channel = RivalIQ.data.channels.get(getSingleChannel(dashboardModel.getProps()));
        const focusCompanyId = dashboardModel.getProp('focusCompanyId');
        const focusCompany = RivalIQ.state.landscape.getCompanyById(focusCompanyId);
        const focusCompanyChannelData = (focusCompany ? focusCompany.getPrimaryRecord(channel.get('source')) : null);

        // Focus company is not on channel.
        if (!focusCompanyChannelData) {
            return {
                observationIconClass: 'fa-warning',
                observationHtml: `We don't have the ${channel.get('name')} handle for ${companyLink(focusCompany)}.`
            };
        }
    };

    function companyHasNoDataInMainPeriod(dashboardModel, observationMetrics) {
        const focusCompanyMainPeriod = observationMetrics[OBSERVATION_METRICS.FocusCompanyMainPeriod];
        const channel = RivalIQ.data.channels.get(getSingleChannel(dashboardModel.getProps()));
        const focusCompanyId = dashboardModel.getProp('focusCompanyId');
        const focusCompany = RivalIQ.state.landscape.getCompanyById(focusCompanyId);
        const focusCompanyChannelData = focusCompany.getPrimaryRecord(channel.get('source'));

        const focusCompanyMainPeriodValue = getSingleMetricValue(observationMetrics, OBSERVATION_METRICS.FocusCompanyMainPeriod);

        // Focus company has no data in the main period.
        if (!_.isFinite(focusCompanyMainPeriodValue)) {
            const date = (focusCompanyMainPeriod.get('property') === 'presence_reach' ? focusCompanyChannelData.dates.earliestPresenceData : focusCompanyChannelData.dates.earliestPostData);

            if (date && moment.utc(date).isAfter(focusCompanyMainPeriod.get('timePeriod').mainPeriodStart)) {
                return true;
            }
        }

        return false;
    }

    // Returns the count of companies with data for this channel. dataByCompany is a sparse set of data from the server;
    // this method counts by adding in companies that are not on channel.
    function getNumCompaniesForChannel(dashboardModel, dataByCompany, benchmarkCompaniesFilter) {
        const allCompanies = _.keyBy(_.clone(dataByCompany), _.head);
        const channel = RivalIQ.data.channels.get(getSingleChannel(dashboardModel.getProps()));
        _.each(App.utils.getCompaniesForFilter(benchmarkCompaniesFilter, dashboardModel), function (company) {
            const companyChannelData = company.getPrimaryRecord(channel.get('source'));
            if (!companyChannelData) {
                // if companyChannelData is null, that means the company is not on the channel. Which counterintuitively
                // means we want to include it in our counts.
                allCompanies[company.id] = 0;
            }
        });

        return _.size(allCompanies);
    }

    // Question: [Audience, Engagement, Engagement Rate] Do you fall above or below the competitive average? What rank does that put you?
    // This is observation 1a in the spec.
    data._generateSingleChannelCompetitiveObservation = function (dashboardModel, observationMetrics) {

        if (!isSingleChannel(dashboardModel.getProps())) {
            // cross-channel
            return;
        }

        const focusCompanyMainPeriod = observationMetrics[OBSERVATION_METRICS.FocusCompanyMainPeriod];
        if (!focusCompanyMainPeriod || !_.includes(SingleChannelCompetitiveMetrics, focusCompanyMainPeriod.get('property'))) {
            return;
        }

        const noDataObservation = data._generateSingleChannelMissingObservation(dashboardModel, observationMetrics);
        if (noDataObservation) {
            return noDataObservation;
        }

        if (companyHasNoDataInMainPeriod(dashboardModel, observationMetrics)) {
            return;
        }

        const focusCompanyId = dashboardModel.getProp('focusCompanyId');
        const focusCompany = RivalIQ.state.landscape.getCompanyById(focusCompanyId);

        const focusCompanyMainPeriodPostsPerDay = getSingleMetricValue(observationMetrics, OBSERVATION_METRICS.FocusCompanyPostsPerDay);
        if (_.includes(['engagement_total', 'avg_engagement_rate_per_post', 'views', 'engagement_total_per_view'], focusCompanyMainPeriod.get('property')) && !focusCompanyMainPeriodPostsPerDay) {
            // [Company published 0 posts in period -- ENGAGEMENT & ENGAGEMENT RATE ONLY]

            if (_.includes(['avg_engagement_rate_per_post', 'engagement_total_per_view'], focusCompanyMainPeriod.get('property'))) {
                return;
            }

            // Company has 0 total engagements because you didn’t post this period.
            const firstSentence = `${companyLink(focusCompany)} has 0 total engagements because you didn't post this period.`;

            const benchmarkPostsPerDay = getSingleMetricValue(observationMetrics, OBSERVATION_METRICS.BenchmarkAveragePostsPerDay);
            let secondSentence;
            if (benchmarkPostsPerDay > 0) {
                secondSentence = 'Try posting more to keep up with the competitor average!';
            }

            return {
                observationIconClass: 'fa-lightbulb-o',
                observationHtml: _.compact([firstSentence, secondSentence]).join(' ')
            };
        }

        const focusCompanyMainPeriodValue = getSingleMetricValue(observationMetrics, OBSERVATION_METRICS.FocusCompanyMainPeriod);
        if (_.includes(['engagement_total', 'avg_engagement_rate_per_post'], focusCompanyMainPeriod.get('property')) && focusCompanyMainPeriodPostsPerDay > 0 && focusCompanyMainPeriodValue === 0) {
            // [Company published posts in period but got no engagement on their posts]

            if (focusCompanyMainPeriod.get('property') === 'avg_engagement_rate_per_post') {
                return;
            }

            // Company received 0 total engagements. Continue experimenting with your content - you can do it!
            return {
                observationIconClass: 'fa-lightbulb-o',
                observationHtml: `${companyLink(focusCompany)} received 0 total engagements. Continue experimenting with your content - you can do it!`
            };
        }

        const dataByCompany = getDataByFreeDimension(observationMetrics, OBSERVATION_METRICS.ByCompany);

        if (dataByCompany.length > 1) {

            // This is the focus company's rank of companies in the current company set filter on this channel (1-based index)
            const focusCompanyRank = _.findIndex(dataByCompany, function (value) {
                return value[0] === focusCompanyId;
            }) + 1;

            const numCompanies = getNumCompaniesForChannel(dashboardModel, dataByCompany, observationMetrics[OBSERVATION_METRICS.BenchmarkAverage].get('benchmarkCompaniesFilter'));

            let encouragementPhrase = '';
            if (focusCompanyRank === 1) {

                switch (focusCompanyMainPeriod.get('property')) {
                    case 'engagement_total':
                        // Company ranks 1st of 84 companies for Facebook Engagement Total. Way to go!
                        encouragementPhrase = ' Way to go!';
                        break;

                    case 'presence_reach':
                        // Company ranks 1st of 84 companies for Facebook Page Fans. Good job!
                        encouragementPhrase = ' Good job!';
                        break;

                    case 'avg_engagement_rate_per_post':
                    default:
                        encouragementPhrase = '';
                }

                return {
                    observationIconClass: 'fa-trophy',
                    observationHtml: `${companyLink(focusCompany)} ranks 1st of ${numCompanies} companies for ${metricName(focusCompanyMainPeriod)}.${encouragementPhrase}`
                };

            } else {
                const average = getSingleMetricValue(observationMetrics, OBSERVATION_METRICS.BenchmarkAverage);

                // If the average is not finite, fall through to the 1 company observations.
                if (_.isFinite(average)) {

                    switch (relationToRange(focusCompanyMainPeriodValue, average)) {
                        case ABOVE_RANGE:

                            switch (focusCompanyMainPeriod.get('property')) {
                                case 'engagement_total':
                                    encouragementPhrase = ' Keep up the good work!';
                                    break;

                                case 'presence_reach':
                                    encouragementPhrase = ' Nice work!';
                                    break;

                                case 'avg_engagement_rate_per_post':
                                default:
                                    encouragementPhrase = '';
                            }

                            return {
                                observationIconClass: 'fa-thumbs-up',
                                observationHtml: `${companyLink(focusCompany)} is above average for ${metricName(focusCompanyMainPeriod)
                                }, ranking ${focusCompanyRank.ordinal()} of ${numCompanies} companies.${encouragementPhrase}`
                            };

                        case NEAR_RANGE:

                            switch (focusCompanyMainPeriod.get('property')) {
                                case 'engagement_total':
                                    encouragementPhrase = ` You're on the right track!`;
                                    break;

                                case 'presence_reach':
                                    encouragementPhrase = ' Keep aiming for the top!';
                                    break;

                                case 'avg_engagement_rate_per_post':
                                default:
                                    encouragementPhrase = '';
                            }

                            return {
                                observationIconClass: 'fa-thumbs-up',
                                observationHtml: `${companyLink(focusCompany)} is about average for ${metricName(focusCompanyMainPeriod)
                                }, ranking ${focusCompanyRank.ordinal()} of ${numCompanies} companies.${encouragementPhrase}`
                            };

                        case BELOW_RANGE:

                            switch (focusCompanyMainPeriod.get('property')) {
                                case 'engagement_total':
                                case 'presence_reach':
                                    encouragementPhrase = ` ${attentionGrabStatement(focusCompanyMainPeriodValue)}`;
                                    break;

                                case 'avg_engagement_rate_per_post':
                                default:
                                    encouragementPhrase = '';
                            }

                            return {
                                observationIconClass: 'fa-flag',
                                observationHtml: `${companyLink(focusCompany)} is below average for ${metricName(focusCompanyMainPeriod)
                                }, ranking ${focusCompanyRank.ordinal()} of ${numCompanies} companies.${encouragementPhrase}`
                            };

                        default:
                            // this should never happen, fallthrough.
                    }
                }
            }
        }
    };

    // [Activity] Do you fall above or below the competitive average? What\'s the posting rate?
    // This is observation 1b in the spec.
    data._generateSingleChannelActivityObservation = function (dashboardModel, observationMetrics) {

        if (!isSingleChannel(dashboardModel.getProps())) {
            // cross-channel
            return;
        }

        const focusCompanyMainPeriod = observationMetrics[OBSERVATION_METRICS.FocusCompanyMainPeriod];
        if (!focusCompanyMainPeriod || !_.includes(SingleChannelCountMetrics, focusCompanyMainPeriod.get('property'))) {
            return;
        }

        const noDataObservation = data._generateSingleChannelMissingObservation(dashboardModel, observationMetrics);
        if (noDataObservation) {
            return noDataObservation;
        }

        if (companyHasNoDataInMainPeriod(dashboardModel, observationMetrics)) {
            return;
        }

        const focusCompanyId = dashboardModel.getProp('focusCompanyId');
        const focusCompany = RivalIQ.state.landscape.getCompanyById(focusCompanyId);

        const focusCompanyPostsPerDay = getSingleMetricValue(observationMetrics, OBSERVATION_METRICS.FocusCompanyPostsPerDay);
        const benchmarkPostsPerDay = getSingleMetricValue(observationMetrics, OBSERVATION_METRICS.BenchmarkAveragePostsPerDay);
        const channel = getSingleChannel(dashboardModel.getProps());

        if (focusCompanyPostsPerDay === 0) {
            // No posts from the focus company in this time period.
            let observation;

            if (channel === RivalIQ.enums.channels.TWITTER) {

                if (_.includes(focusCompanyMainPeriod.get('exclusions'), 'normal')) {
                    return;
                }

                observation = `${companyLink(focusCompany)} posted 0 normal tweets this period`;
            } else {
                observation = `${companyLink(focusCompany)} didn't post this period`;
            }
            if (_.isFinite(benchmarkPostsPerDay) && benchmarkPostsPerDay > 0) {
                observation += `, but competitors are posting ${formatPostsPerPeriod(observationMetrics[OBSERVATION_METRICS.BenchmarkAveragePostsPerDay])}`;
            }
            observation += '. You should post something &mdash; your followers want to hear from you!';

            return {
                observationIconClass: 'fa-lightbulb-o',
                observationHtml: observation
            };
        }

        const dataByCompany = getDataByFreeDimension(observationMetrics, OBSERVATION_METRICS.ByCompany);

        const channelName = RivalIQ.data.channels.get(channel).get('name');
        const postsPerDayRec = POSTS_PER_DAY_RECS[channel];
        const numMainPeriodPosts = getSingleMetricValue(observationMetrics, OBSERVATION_METRICS.FocusCompanyMainPeriod);
        const postWord = RivalIQ.data.channels.get(channel).get('postName');
        const publishedString = `published ${App.utils.numToWords(numMainPeriodPosts)
        }${channel === RivalIQ.enums.channels.TWITTER ? ' normal ' : ' '}${postWord}${numMainPeriodPosts > 1 ? 's' : ''}`;
        let publishRateString = ` (${formatPostsPerPeriod(observationMetrics[OBSERVATION_METRICS.FocusCompanyPostsPerDay], true)})`;
        if (observationMetrics[OBSERVATION_METRICS.FocusCompanyPostsPerDay].get('timePeriod').mainPeriodDuration === 1) {
            publishRateString = '';
        }

        const compareAgainst = _.find(RivalIQ.enums.benchmarkCompareAgainstOptions, {
            benchmarkCompaniesFilter: observationMetrics[OBSERVATION_METRICS.BenchmarkAveragePostsPerDay].get('benchmarkCompaniesFilter'),
            aggregate: observationMetrics[OBSERVATION_METRICS.BenchmarkAveragePostsPerDay].get('aggregate')
        });
        const isCompareAgainstOneCompany = App.utils.getCompaniesForFilter(compareAgainst.benchmarkCompaniesFilter, dashboardModel).length === 1;
        const otherCompaniesName = otherCompanyLink(compareAgainst, dashboardModel);
        const otherCompaniesNamePossessive = otherCompanyLink(compareAgainst, dashboardModel, true);

        if (postsPerDayRec) {
            if (dataByCompany.length > 1) {
                let postingObs;
                let iconClass;

                switch (relationToRange(focusCompanyPostsPerDay, postsPerDayRec)) {
                    case ABOVE_RANGE: {
                        // focus company posts more than recommended.
                        postingObs = `${companyLink(focusCompany)} ${publishedString}${publishRateString}`;

                        if (_.isFinite(benchmarkPostsPerDay)) {

                            switch (relationToRange(focusCompanyPostsPerDay, benchmarkPostsPerDay)) {
                                case ABOVE_RANGE: {
                                    // Company published 100 posts (21 per week), more frequently than [competitor name/your average competitor/the landscape average]. Posting more than 21 times per week may increase your engagement while decreasing your reach on each post.
                                    postingObs += `, more frequently than ${otherCompaniesName}.`;
                                    postingObs += ' Posting more than ';

                                    const upperRecRange = _.last(postsPerDayRec);
                                    const timePeriod = observationMetrics[OBSERVATION_METRICS.FocusCompanyPostsPerDay].get('timePeriod');
                                    const timePeriodDurationDays = moment.utc(timePeriod.mainPeriodEnd).diff(timePeriod.mainPeriodStart, 'day', true);
                                    if (timePeriodDurationDays > 7) {
                                        postingObs += `${upperRecRange * 7} times per week`;
                                    } else {
                                        postingObs += `${upperRecRange} times per day`;
                                    }

                                    postingObs += ' may increase your engagement while decreasing your reach on each post.';

                                    break;
                                }

                                case NEAR_RANGE: {
                                    // Company published 100 posts (21 per week), right in line with [competitor name/your average competitor/the landscape average]. While posting this frequently is likely to increase your total engagement, you may find fewer reach on each post.
                                    postingObs += `, right in line with ${otherCompaniesName}. While posting this frequently is likely to increase your total engagement, you may find less reach on each ${postWord}.`;
                                    break;
                                }

                                case BELOW_RANGE: {
                                    // Company published 100 posts (21 per week), [fewer than competitor name/ below your average competitor/below the landscape average]. Consider experimenting with more posts to potentially increase your overall engagement on Facebook.
                                    if (isCompareAgainstOneCompany) {
                                        postingObs += `, fewer than ${otherCompaniesName}`;
                                    } else {
                                        postingObs += `, below ${otherCompaniesName}`;
                                    }
                                    postingObs += `. Consider experimenting with more posts to potentially increase your overall engagement on ${channelName}.`;
                                    break;
                                }

                                default:
                                    // this should never happen, fallthrough.
                            }

                        } else {
                            postingObs += '.';
                        }

                        return {
                            observationIconClass: 'fa-lightbulb-o',
                            observationHtml: postingObs,
                            observationTooltip: data._ActivityRecommendationTooltipContent
                        };
                    }

                    case NEAR_RANGE: {
                        // focus company is around the recommendation.
                        postingObs = `${companyLink(focusCompany)} ${publishedString}`;
                        iconClass = 'fa-thumbs-up';

                        if (_.isFinite(benchmarkPostsPerDay)) {

                            switch (relationToRange(focusCompanyPostsPerDay, benchmarkPostsPerDay)) {
                                // Company published 30 posts this period. Good job posting about six times per week, ahead of [Bally’s/your average competitor’s/the landscape average of] four posts per week.
                                case ABOVE_RANGE: {
                                    postingObs += ` this period. Good job posting ${formatPostsPerPeriod(observationMetrics[OBSERVATION_METRICS.FocusCompanyPostsPerDay])}`;

                                    if (isCompareAgainstOneCompany || compareAgainst.benchmarkCompaniesFilter === RivalIQ.enums.benchmarkCompaniesFilters.exclude_focus_company.id) {
                                        postingObs += `, ahead of ${otherCompaniesNamePossessive} ${formatPostsPerPeriod(observationMetrics[OBSERVATION_METRICS.BenchmarkAveragePostsPerDay])}.`;
                                    } else {
                                        postingObs += `, ahead of ${otherCompaniesName} of ${formatPostsPerPeriod(observationMetrics[OBSERVATION_METRICS.BenchmarkAveragePostsPerDay])}.`;
                                    }
                                    break;
                                }

                                // Company published 30 posts this period (about five posts per week), right in line with [competitor name/your average competitor/the landscape average]. Good job posting consistently!
                                case NEAR_RANGE: {
                                    postingObs += ` this period (${formatPostsPerPeriod(observationMetrics[OBSERVATION_METRICS.FocusCompanyPostsPerDay])}), right in line with ${otherCompaniesName}. Good job posting consistently!`;
                                    break;
                                }

                                // Company published 30 posts this period. Nice work posting about five times per week.
                                case BELOW_RANGE: {
                                    postingObs += ` this period. Nice work posting ${formatPostsPerPeriod(observationMetrics[OBSERVATION_METRICS.FocusCompanyPostsPerDay])}.`;
                                    break;
                                }

                                default:
                                    // this should never happen, fallthrough.
                            }

                        } else {
                            postingObs += `${publishRateString}.`;
                        }

                        return {
                            observationIconClass: iconClass,
                            observationHtml: postingObs
                        };
                    }

                    case BELOW_RANGE: {
                        // focus company posts less than recommended.
                        postingObs = `${companyLink(focusCompany)} ${publishedString}`;

                        if (_.isFinite(benchmarkPostsPerDay)) {

                            switch (relationToRange(focusCompanyPostsPerDay, benchmarkPostsPerDay)) {
                                case ABOVE_RANGE: {
                                    // Company published 10 posts, or only 3 posts per week. Although this is more frequent than [competitor name/your average competitor/the landscape average], we'd still recommend posting more, about once per day.
                                    postingObs += `, or only ${formatPostsPerPeriod(observationMetrics[OBSERVATION_METRICS.FocusCompanyPostsPerDay])}. ` +
                                        `Although this is more frequent than ${otherCompaniesName
                                        }, we'd still recommend posting more, about once per day.`;
                                    break;
                                }

                                case NEAR_RANGE: {
                                    // Company published 10 posts, or only 3 posts per week. Although this is right in line with [competitor name/your average competitor/the landscape average], we recommend increasing your posting to about once per day.
                                    postingObs += `, or only ${formatPostsPerPeriod(observationMetrics[OBSERVATION_METRICS.FocusCompanyPostsPerDay])}. ` +
                                        `Although this is right in line with ${otherCompaniesName
                                        }, we recommend increasing your posting to about once per day.`;
                                    break;
                                }

                                case BELOW_RANGE: {
                                    // Company published 10 posts (3 per week), [fewer than competitor name/below your average competitor/below the landscape average]. We recommend posting about once per day because your followers want to hear from you!
                                    postingObs += publishRateString;

                                    if (isCompareAgainstOneCompany) {
                                        postingObs += `, fewer than ${otherCompaniesName}`;
                                    } else {
                                        postingObs += `, below ${otherCompaniesName}`;
                                    }
                                    postingObs += `. We recommend ${postWord}ing about once per day because your followers want to hear from you!`;
                                    break;
                                }

                                default:
                                    // this should never happen, fallthrough.
                            }

                        } else {
                            postingObs += `${publishRateString}.`;
                        }

                        return {
                            observationIconClass: 'fa-lightbulb-o',
                            observationHtml: postingObs,
                            observationTooltip: data._ActivityRecommendationTooltipContent
                        };
                    }

                    default:
                        // this should never happen, fallthrough.
                }

            } else {

                // There's no other companies to compare to, fallback to single company observations.
                switch (relationToRange(focusCompanyPostsPerDay, postsPerDayRec)) {
                    case ABOVE_RANGE: {
                        // focus company posts more than recommended.
                        // Company published 100 posts, or 15 posts per week. But remember, posting more can reduce the chances of followers seeing and engaging with each of your posts.
                        return {
                            observationIconClass: 'fa-lightbulb-o',
                            observationHtml: `${companyLink(focusCompany)} ${publishedString}, or ${formatPostsPerPeriod(observationMetrics[OBSERVATION_METRICS.FocusCompanyPostsPerDay])}. ` +
                                `But remember, ${postWord}ing more can reduce the chances  of followers seeing and engaging with each of your ${postWord}s.`
                        };
                    }

                    case NEAR_RANGE: {
                        // focus company is around the recommendation.
                        // Company published 100 posts, or one post per day. Good job consistently engaging with your followers!
                        return {
                            observationIconClass: 'fa-thumbs-up',
                            observationHtml: `${companyLink(focusCompany)} ${publishedString}, or ${formatPostsPerPeriod(observationMetrics[OBSERVATION_METRICS.FocusCompanyPostsPerDay])}. ` +
                                'Good job consistently engaging with your followers!'
                        };
                    }

                    case BELOW_RANGE: {
                        // focus company posts less than recommended.
                        // Company published 100 posts, or only 3 posts per week. We recommend posting at least once per day because your followers want to hear from you!
                        return {
                            observationIconClass: 'fa-lightbulb-o',
                            observationHtml: `${companyLink(focusCompany)} ${publishedString}, or only ${formatPostsPerPeriod(observationMetrics[OBSERVATION_METRICS.FocusCompanyPostsPerDay])}. ` +
                                `We recommend ${postWord}ing at least once per day because your followers want to hear from you!`
                        };
                    }

                    default:
                        // this should never happen, fallthrough.
                }
            }
        } else {

            let noRecPostingObs = `${companyLink(focusCompany)} ${publishedString}${publishRateString}`;
            if (dataByCompany.length > 1) {

                if (_.isFinite(benchmarkPostsPerDay)) {

                    switch (relationToRange(focusCompanyPostsPerDay, benchmarkPostsPerDay)) {
                        case ABOVE_RANGE: {
                            // Company published 100 posts (15 per week), more frequently than [competitor name/your average competitor/the landscape average].
                            noRecPostingObs += `, more frequently than ${otherCompaniesName}`;
                            break;
                        }

                        case NEAR_RANGE: {
                            // Company published 100 posts (15 per week), right in line with [competitor name/your average competitor/the landscape average].
                            noRecPostingObs += `, right in line with ${otherCompaniesName}`;
                            break;
                        }

                        case BELOW_RANGE: {
                            // Company published 100 posts (15 per week), [fewer than competitor name/ below your average competitor/below the landscape average]
                            if (isCompareAgainstOneCompany) {
                                noRecPostingObs += `, fewer than ${otherCompaniesName}`;
                            } else {
                                noRecPostingObs += `, below ${otherCompaniesName}`;
                            }
                            break;
                        }

                        default:
                            // this should never happen, fallthrough.
                    }

                    noRecPostingObs += '.';
                } else {
                    noRecPostingObs += '.';
                }
            } else {
                noRecPostingObs += '.';
            }

            return {
                observationIconClass: 'fa-flag',
                observationHtml: noRecPostingObs
            };
        }
    };

    function findCompaniesWithAudienceStart(source, dashboardModel) {
        const companies = RivalIQ.state.landscape.getCompaniesByCompanySet(dashboardModel.getProp('companySetDescriptor'));
        const timePeriod = dashboardModel.getProp('timePeriod');

        const mainPeriodStart = moment.utc(timePeriod.mainPeriodStart).startOf('day');
        const mainPeriodEnd = moment.utc(timePeriod.mainPeriodEnd).endOf('day');

        const companiesWithAudienceStart = _.filter(companies, company => {
            const companyChannelData = company.getPrimaryRecord(source);

            const earliestPresenceData = _.get(companyChannelData, ['dates', 'earliestPresenceData']);
            if (earliestPresenceData) {

                return mainPeriodStart.isSameOrBefore(earliestPresenceData) &&
                    mainPeriodEnd.isAfter(earliestPresenceData);
            }
        });

        return companiesWithAudienceStart;
    }

    // Observes if one or more companies just started getting audience data for one or more channels in the main time period.
    data._generateAudienceStartedObservations = function (dashboardModel, observationMetrics) {
        if (isSingleChannel(dashboardModel.getProps())) {
            return;
        }

        const focusCompanyMainPeriod = observationMetrics[OBSERVATION_METRICS.FocusCompanyMainPeriod];
        if (!focusCompanyMainPeriod || !_.includes(['audience', 'presence_reach'], focusCompanyMainPeriod.get('property'))) {
            return;
        }

        const excludedChannels = focusCompanyMainPeriod.get('exclusions');
        const channels = RivalIQ.data.channels.inCrossChannel().forAnalyze().withAccess().notHidden(true).filter(channel => {
            return !_.includes(excludedChannels, channel.get('channel'));
        });

        const sourceToCompaniesWithAudienceStart = channels.reduce((memo, channel) => {
            const source = channel.get('source');
            const companiesWithAudienceStart = findCompaniesWithAudienceStart(source, dashboardModel);

            if (companiesWithAudienceStart.length) {
                memo[source] = companiesWithAudienceStart;
            }

            return memo;
        }, {});


        if (!_.isEmpty(sourceToCompaniesWithAudienceStart)) {

            const channelsWithAudienceStart = _.keys(sourceToCompaniesWithAudienceStart);
            if (channelsWithAudienceStart.length === 1) {
                // Only one channel had companies with new audience data.
                const companiesWithAudienceStart = sourceToCompaniesWithAudienceStart[channelsWithAudienceStart];
                const channelData = RivalIQ.data.channels.get(Number(channelsWithAudienceStart[0]));
                if (companiesWithAudienceStart.length === 1) {
                    return {
                        observationIconClass: channelData.get('fontIcon'),
                        observationHtml: `${channelData.get('name')} was added to ${companyLink(companiesWithAudienceStart[0])} during this time period.`
                    };
                } else if (companiesWithAudienceStart.length > 0) {
                    const focusCompanyId = dashboardModel.getProp('focusCompanyId');
                    const focusCompany = _.find(companiesWithAudienceStart, company => company.id === focusCompanyId);

                    if (focusCompany) {
                        const numOtherCompanies = companiesWithAudienceStart.length - 1;
                        const otherCompaniesWord = (numOtherCompanies > 1 ? 'companies' : 'company');
                        return {
                            observationIconClass: channelData.get('fontIcon'),
                            observationHtml: `${channelData.get('name')} was added to ${companyLink(focusCompany)} and ${App.utils.numToWords(numOtherCompanies)} other ${otherCompaniesWord} during this time period.`
                        };
                    } else {
                        const numCompanies = companiesWithAudienceStart.length;
                        const companiesWord = (numCompanies > 1 ? 'companies' : 'company');
                        return {
                            observationIconClass: channelData.get('fontIcon'),
                            observationHtml: `${channelData.get('name')} was added to ${App.utils.numToWords(numCompanies)} ${companiesWord} during this time period.`
                        };
                    }
                }
            } else {
                // Multiple channels have companies with new audience data.
                const companiesWithAudienceStart = _(sourceToCompaniesWithAudienceStart)
                    .values()
                    .flatten()
                    .uniq('id')
                    .value();
                if (companiesWithAudienceStart.length === 1) {
                    return {
                        observationIconClass: 'fa-plus-square',
                        observationHtml: `New handles were added to ${companyLink(companiesWithAudienceStart[0])} during this time period.`
                    };
                } else {
                    const focusCompanyId = dashboardModel.getProp('focusCompanyId');
                    const focusCompany = _.find(companiesWithAudienceStart, company => company.id === focusCompanyId);

                    if (focusCompany) {
                        const numOtherCompanies = companiesWithAudienceStart.length - 1;
                        const otherCompaniesWord = (numOtherCompanies > 1 ? 'companies' : 'company');
                        return {
                            observationIconClass: 'fa-plus-square',
                            observationHtml: `New handles were added to ${companyLink(focusCompany)} and ${App.utils.numToWords(numOtherCompanies)} other ${otherCompaniesWord} during this time period.`
                        };
                    } else {
                        const numCompanies = companiesWithAudienceStart.length;
                        const companiesWord = (numCompanies > 1 ? 'companies' : 'company');
                        return {
                            observationIconClass: 'fa-plus-square',
                            observationHtml: `New handles were added to ${App.utils.numToWords(numCompanies)} ${companiesWord} during this time period.`
                        };
                    }
                }
            }
        }
    };

    // This is the Twitter specific section of the spec, single channel 1b.
    data._generateTwitterActivityObservation = function (dashboardModel, observationMetrics) {
        const channel = getSingleChannel(dashboardModel.getProps());
        const focusCompanyMainPeriod = observationMetrics[OBSERVATION_METRICS.FocusCompanyMainPeriod];

        if (channel !== RivalIQ.enums.channels.TWITTER ||
            !_.includes(SingleChannelCountMetrics, focusCompanyMainPeriod.get('property')) || // this only applies to twitter activity
            !_.isEmpty(_.intersection(['normal', 'replies'], focusCompanyMainPeriod.get('exclusions')))) { // if the exclusions contains normal or replies, bail out
            return;
        }

        const focusCompanyId = dashboardModel.getProp('focusCompanyId');
        const focusCompany = RivalIQ.state.landscape.getCompanyById(focusCompanyId);
        const focusCompanyChannelData = focusCompany.getPrimaryRecord(RivalIQ.data.channels.get(channel).get('source'));

        // Focus company is not on channel.
        if (!focusCompanyChannelData) {
            return;
        }

        const focusCompanyActivityByTweetType = _(getDataByFreeDimension(observationMetrics, OBSERVATION_METRICS.FocusCompanyMainPeriodTweetsByType))
            .keyBy(_.head)
            .mapValues(_.last)
            .value();

        const benchmarkActivityByTweetType = _(getDataByFreeDimension(observationMetrics, OBSERVATION_METRICS.BenchmarkAverageMainPeriodTweetsByType))
            .keyBy(_.head)
            .mapValues(_.last)
            .value();

        const compareAgainst = _.find(RivalIQ.enums.benchmarkCompareAgainstOptions, {
            benchmarkCompaniesFilter: observationMetrics[OBSERVATION_METRICS.BenchmarkAverageMainPeriodTweetsByType].get('benchmarkCompaniesFilter'),
            aggregate: observationMetrics[OBSERVATION_METRICS.BenchmarkAverageMainPeriodTweetsByType].get('aggregate')
        });
        const otherCompaniesName = otherCompanyLink(compareAgainst, dashboardModel, false, 'your landscape');
        let ratePhrase;

        if (!focusCompanyActivityByTweetType.reply) {
            // Focus company didn't do any reply tweets.

            if (benchmarkActivityByTweetType.reply >= 10) {
                // And the benchmark did have some replies.

                if (benchmarkActivityByTweetType.normal) {
                    const benchmarkReplyMagnitude = benchmarkActivityByTweetType.reply / benchmarkActivityByTweetType.normal;
                    const rateMultiplier = calculateMultiplierRateForDisplay(benchmarkReplyMagnitude);

                    if (benchmarkReplyMagnitude > 1.2) {
                        // You could engage with other handles more — [competitor name/your average competitor/your landscape] replies 10x more than they tweet.
                        if (rateMultiplier === 1) {
                            ratePhrase = 'more often than they tweet.';
                        } else if (rateMultiplier === 2) {
                            ratePhrase = 'twice as much as they tweet.';
                        } else {
                            ratePhrase = `${rateMultiplier}x more than they tweet.`;
                        }

                        return {
                            observationIconClass: 'fa-reply',
                            observationHtml: `You could engage with other handles more &mdash; ${
                                otherCompaniesName} replies ${ratePhrase}`
                        };
                    } else if (benchmarkReplyMagnitude < 0.8) {
                        // You could engage with other handles more — [competitor name/your average competitor/your landscape] replies once for every five tweets.

                        const numNormalTweetsPerReply = calculateMultiplierRateForDisplay(benchmarkActivityByTweetType.normal / benchmarkActivityByTweetType.reply);
                        if (numNormalTweetsPerReply <= 1) {
                            ratePhrase = ' replies about as often as they tweet.';
                        } else if (numNormalTweetsPerReply <= 2) {
                            ratePhrase = ' replies about once for every other tweet.';
                        } else {
                            ratePhrase = ` replies once for every ${App.utils.numToWords(numNormalTweetsPerReply)} tweets.`;
                        }

                        return {
                            observationIconClass: 'fa-reply',
                            observationHtml: `You could engage with other handles more &mdash; ${
                                otherCompaniesName}${ratePhrase}`
                        };
                    } else {
                        // reply_magnitude between 0.8 - 1.2
                        // You could engage with other handles more — [competitor name/your average competitor/your landscape] replies as much as they tweet.

                        return {
                            observationIconClass: 'fa-reply',
                            observationHtml: `You could engage with other handles more &mdash; ${
                                otherCompaniesName} replies as much as they tweet.`
                        };
                    }
                } else {
                    // benchmark has replies and no normal tweets
                    // You could engage with other handles more — [competitor name/your average competitor/your landscape] replied X times this period.

                    return {
                        observationIconClass: 'fa-reply',
                        observationHtml: `You could engage with other handles more &mdash; ${
                            otherCompaniesName} replied ${RivalIQ.formatter.formats.integer(benchmarkActivityByTweetType.reply)} times this period.`
                    };
                }
            }
        } else {
            // focus company did have some replies this period.

            const replyValueMagnitude = benchmarkActivityByTweetType.reply / focusCompanyActivityByTweetType.reply;
            const focusReplyPercentage = focusCompanyActivityByTweetType.reply / _.sum(_.values(focusCompanyActivityByTweetType));
            const benchmarkReplyPercentage = benchmarkActivityByTweetType.reply / _.sum(_.values(benchmarkActivityByTweetType));
            const replyBreakdownMagnitude = benchmarkReplyPercentage / focusReplyPercentage;

            if (replyValueMagnitude >= 1.5 &&
                replyBreakdownMagnitude >= 1.5 &&
                benchmarkActivityByTweetType.reply >= 10) {
                // You could engage with other handles more — [competitor name/your average competitor/your landscape] sends 4x more reply tweets than you do

                ratePhrase = `${calculateMultiplierRateForDisplay(replyValueMagnitude)}x more reply tweets than you do.`;

                return {
                    observationIconClass: 'fa-reply',
                    observationHtml: `You could engage with other handles more &mdash; ${
                        otherCompaniesName} sends ${ratePhrase}`
                };
            }
        }
    };

    function decreasedValueExplainerSentence(dashboardModel, observationMetrics) {
        const focusCompanyMainPeriod = observationMetrics[OBSERVATION_METRICS.FocusCompanyMainPeriod];
        const metricProperty = focusCompanyMainPeriod.get('property');

        if (metricProperty === 'engagement_total' || metricProperty === 'views') {
            const postWord = RivalIQ.data.channels.get(getSingleChannel(dashboardModel.getProps())).get('postName');
            const focusCompanyPostsDelta = getSingleMetricValue(observationMetrics, OBSERVATION_METRICS.FocusCompanyPercentChangeNumPosts);
            const currEngTotalPerPost = getSingleMetricValue(observationMetrics, OBSERVATION_METRICS.FocusCompanyMainPeriodEngTotalPerPost);
            const prevNumPosts = getSingleMetricValue(observationMetrics, OBSERVATION_METRICS.FocusCompanyComparePeriodNumPosts);
            const prevEngTotal = getSingleMetricValue(observationMetrics, OBSERVATION_METRICS.FocusCompanyComparePeriodEngTotal);

            if (focusCompanyPostsDelta === -1 || // focusCompanyPostsDelta of -100% means they didn't post at all this period.
                (focusCompanyPostsDelta < 0 && (currEngTotalPerPost * prevNumPosts >= prevEngTotal * 0.95))) {
                return `You published fewer ${postWord}s this period, which can help explain your decrease.`;
            } else {

                const prevTopPostEngTotal = getSingleMetricValue(observationMetrics, OBSERVATION_METRICS.FocusCompanyComparePeriodBestPost);
                const currTopPostEngTotal = getSingleMetricValue(observationMetrics, OBSERVATION_METRICS.FocusCompanyMainPeriodBestPost);

                if (prevTopPostEngTotal > ABOVE_VALUE_THRESHOLD * currTopPostEngTotal) {
                    if (currTopPostEngTotal !== 0) {
                        const engagementMultiplier = Math.round(prevTopPostEngTotal / currTopPostEngTotal);
                        return `Your top ${postWord} received ${engagementMultiplier}x fewer engagements than your previous top ${postWord}, which can help explain your decrease.`;
                    }
                } else {
                    if (metricProperty === 'engagement_total') {
                        return `You received fewer engagements across each ${postWord} this period, which can help explain your decrease.`;
                    }
                }
            }
        }
    }

    // Rounding rules for strings like "twice as fast as" vs "1.5x the rate"
    // - round to the nearest 0.5
    // - if the number is >= 4, just round to the nearest whole number.
    function calculateMultiplierRateForDisplay(rateMultiplier) {
        if (rateMultiplier >= 4) {
            return Math.round(rateMultiplier);
        } else {
            return Math.round(2 * rateMultiplier) / 2;
        }
    }

    // This is refactored from the "Audience thresholds for time and channel" growth code from the spec.
    function getAverageDailyGrowthRate(pctChangeMetric) {
        const FLAT_GROWTH_BOUNDARY_BY_DAY = Math.pow(1.05, 1.0 / 365) - 1; // translate 5% annual growth to daily

        const growthPercentage = _.get(pctChangeMetric.getValue({
            format: false
        }), [0, 0]);

        // NOTE: intentionally not using mainPeriodDuration here as we want to handle non-abutting time periods.
        const timePeriod = pctChangeMetric.get('timePeriod');
        const daysInPeriod = moment.utc(timePeriod.mainPeriodEnd).diff(timePeriod.comparePeriodEnd, 'days');

        // normalize the growth into a daily growth figure
        const avgDailyGrowth = Math.pow(1 + growthPercentage, 1.0 / daysInPeriod) - 1;

        // now compare the abs value of the daily growth to our definition of "flat"
        if (Math.abs(avgDailyGrowth) < FLAT_GROWTH_BOUNDARY_BY_DAY) {
            // This is flat growth.
            return 0;
        } else {
            // This is not flat growth.
            return avgDailyGrowth;
        }
    }

    function randomPositiveStatement() {
        const statements = [
            'Good job!',
            'Way to go!',
            'Nice work!',
            'Keep up the good work!'
        ];

        return _.sample(statements);
    }

    function attentionGrabStatement(seed) {
        const statements = [
            'This is a good place to focus your attention.',
            'Try putting some energy here.',
            `There's more work to do here.`
        ];

        return statements[Math.abs(Math.round(seed || 0) % statements.length)];
    }


    // [Audience, Engagement] Is your change in line with the competitive average?
    // This is observation 2a in the spec
    data._generateSingleChannelChangeObservation = function (dashboardModel, observationMetrics) {

        if (!isSingleChannel(dashboardModel.getProps())) {
            // cross-channel
            return;
        }

        const focusCompanyMainPeriod = observationMetrics[OBSERVATION_METRICS.FocusCompanyMainPeriod];
        const metricProperty = focusCompanyMainPeriod.get('property');
        if (!_.includes(SingleChannelPercentChangedMetrics, metricProperty)) {
            return;
        }

        const focusCompanyPercentChanged = getSingleMetricValue(observationMetrics, OBSERVATION_METRICS.FocusCompanyPercentChange);
        const focusCompanyPercentChangedFormatted = RivalIQ.formatter.formats.percentAbsolute(Math.abs(focusCompanyPercentChanged));

        if (!_.isFinite(focusCompanyPercentChanged)) {
            return;
        }

        const focusCompanyMainPeriodValue = getSingleMetricValue(observationMetrics, OBSERVATION_METRICS.FocusCompanyMainPeriod);
        if (focusCompanyMainPeriodValue === 0) {
            return;
        }

        const benchmarkPercentChanged = getSingleMetricValue(observationMetrics, OBSERVATION_METRICS.BenchmarkAveragePercentChanged);
        const dataByCompany = getDataByFreeDimension(observationMetrics, OBSERVATION_METRICS.ByCompany);

        const benchmarkAverage = getSingleMetricValue(observationMetrics, OBSERVATION_METRICS.BenchmarkAverage);

        const focusCompanyAverageDailyGrowthRate = getAverageDailyGrowthRate(observationMetrics[OBSERVATION_METRICS.FocusCompanyPercentChange]);
        const benchmarkAverageDailyGrowthRate = getAverageDailyGrowthRate(observationMetrics[OBSERVATION_METRICS.BenchmarkAveragePercentChanged]);

        const focusCompanyId = dashboardModel.getProp('focusCompanyId');
        const focusCompany = RivalIQ.state.landscape.getCompanyById(focusCompanyId);
        let firstSentence;
        let secondSentence;

        const compareAgainst = _.find(RivalIQ.enums.benchmarkCompareAgainstOptions, {
            benchmarkCompaniesFilter: observationMetrics[OBSERVATION_METRICS.BenchmarkAveragePercentChanged].get('benchmarkCompaniesFilter'),
            aggregate: observationMetrics[OBSERVATION_METRICS.BenchmarkAveragePercentChanged].get('aggregate')
        });
        const isCompareAgainstOneCompany = App.utils.getCompaniesForFilter(compareAgainst.benchmarkCompaniesFilter, dashboardModel).length === 1;
        let otherCompaniesName = otherCompanyLink(compareAgainst, dashboardModel, false, 'your landscape');
        const otherCompaniesNamePossessive = otherCompanyLink(compareAgainst, dashboardModel, true, 'your landscape'); // HERE see if tiffany wants diff straings.

        if (dataByCompany.length > 1 && _.isFinite(benchmarkPercentChanged) && _.isFinite(benchmarkAverage) && _.isFinite(focusCompanyMainPeriodValue)) {
            // There are 2+ companies

            if (metricProperty === 'presence_reach') {
                // Audience

                if (focusCompanyAverageDailyGrowthRate > 0) {
                    // You increased

                    if (benchmarkAverageDailyGrowthRate > 0) {
                        // They increased

                        if ((focusCompanyAverageDailyGrowthRate / benchmarkAverageDailyGrowthRate - 1) >= 0.1) {
                            // They increased, but you increased more (>= 10% difference)
                            // Copy: You grew your audience and your rate of growth outpaced [company name’s/the average competitor/your landscape]. Way to grow!

                            return {
                                observationIconClass: 'fa-thumbs-up',
                                observationHtml: `You grew your audience and your rate of growth outpaced ${otherCompaniesNamePossessive}. Way to grow!`
                            };
                        }

                        if ((benchmarkAverageDailyGrowthRate / focusCompanyAverageDailyGrowthRate - 1) >= 0.1) {
                            // They increased, and they increased more (>= 10% difference)
                            // Copy: Though your audience grew, your rate of growth was lower than [company name’s/the average competitor’s/your landscape’s]. Keep moving upward by posting more of what works well and less of what doesn’t.

                            return {
                                observationIconClass: 'fa-thumbs-up',
                                observationHtml: `Though your audience grew, your rate of growth was lower than ${otherCompaniesNamePossessive}. Keep moving upward by posting more of what works well and less of what doesn't.`
                            };
                        }


                        // They increased, about the same as your increase (< 10% difference)
                        // Copy: You and [company name/the average competitor/your landscape] saw audience growth during this period. Way to grow!
                        return {
                            observationIconClass: 'fa-thumbs-up',
                            observationHtml: `You and ${otherCompaniesName} saw audience growth during this period. Way to grow!`
                        };

                    } else {

                        // They decreased or didn't change
                        // Copy: You grew your audience during this period, while [company name/the average competitor/your landscape] didn’t grow. Way to outperform!
                        return {
                            observationIconClass: 'fa-thumbs-up',
                            observationHtml: `You grew your audience during this period, while ${otherCompaniesName} didn't grow. Way to outperform!`
                        };
                    }
                } else if (focusCompanyAverageDailyGrowthRate === 0) {
                    // You were flat

                    if (benchmarkAverageDailyGrowthRate > 0) {
                        // They increased
                        // Copy: Your audience size was relatively flat, and [company name/the average competitor/your landscape] grew at a faster rate during this period. Keep posting high-engagement content you know your audience will love.
                        return {
                            observationIconClass: 'fa-flag',
                            observationHtml: `Your audience size was relatively flat, and ${otherCompaniesName} grew at a faster rate during this period. Keep posting high-engagement content you know your audience will love.`
                        };

                    } else {
                        // They decreased or didn’t change
                        // Copy: Like [company name/the average competitor/your landscape], you didn’t see much audience growth this period. Focus on posting high-engagement content to attract new [followers/fans]
                        return {
                            observationIconClass: 'fa-flag',
                            observationHtml: `Like ${otherCompaniesName}, you didn't see much audience growth this period. Focus on posting high-engagement content to attract new ${focusCompanyMainPeriod.getName().toLowerCase()}.`
                        };
                    }
                } else {
                    // You decreased

                    if (benchmarkAverageDailyGrowthRate >= 0) {
                        // They increased, or didn’t change
                        // Copy: Your audience shrunk during this period. Get back into growth mode by creating and sharing content your fans can’t help but engage with.
                        return {
                            observationIconClass: 'fa-thumbs-down',
                            observationHtml: `Your audience shrunk during this period. Get back into growth mode by creating and sharing content your fans can't help but engage with.`
                        };
                    } else if ((focusCompanyAverageDailyGrowthRate / benchmarkAverageDailyGrowthRate - 1) >= 0.1) {
                        // They decreased, but you decreased more (>= 10% difference)
                        // Your audience shrunk at a faster rate than [[company name’s/your average competitor/your landscape]. Focus on posting consistently and creating high-engagement content to get back to growing.

                        return {
                            observationIconClass: 'fa-thumbs-down',
                            observationHtml: `Your audience shrunk at a faster rate than ${otherCompaniesNamePossessive}. Focus on posting consistently and creating high-engagement content to get back to growing.`
                        };
                    } else if ((benchmarkAverageDailyGrowthRate / focusCompanyAverageDailyGrowthRate - 1) >= 0.1) {
                        // They decreased, and they decreased more (>= 10% difference)
                        // Though your audience shrunk, your rate of decrease was lower than [company name’s/your average competitor’s/your landscape’s]. Stay focused on posting consistently and creating high-engagement content to move into positive territory.

                        return {
                            observationIconClass: 'fa-thumbs-down',
                            observationHtml: `Though your audience shrunk, your rate of decrease was lower than ${otherCompaniesNamePossessive}. Stay focused on posting consistently and creating high-engagement content to move into positive territory.`
                        };
                    } else {
                        // They decreased, about the same as your decrease (< 10% difference)
                        // Copy: You and [company name both/your average competitor/your landscape] saw shrinking audiences during this period. Get back into growth mode by creating and sharing content your fans can’t help but engage with.
                        if (isCompareAgainstOneCompany) {
                            otherCompaniesName += ' both';
                        }
                        return {
                            observationIconClass: 'fa-thumbs-down',
                            observationHtml: `You and ${otherCompaniesName} saw shrinking audiences during this period. Get back into growth mode by creating and sharing content your fans can't help but engage with.`
                        };
                    }
                }
            } else if (_.includes(['engagement_total', 'views'], metricProperty)) {
                const metricName = metricProperty === 'engagement_total' ? 'total engagement' : 'views';
                if (focusCompanyAverageDailyGrowthRate > 0) {
                    // You increased

                    if (benchmarkAverageDailyGrowthRate > 0 && focusCompanyAverageDailyGrowthRate > benchmarkAverageDailyGrowthRate) {
                        // They increased, but you increased more
                        // Copy: Your engagement increased during this period, and you outpaced [company name/your average competitor/your landscape]. Look at you!
                        return {
                            observationIconClass: 'fa-thumbs-up',
                            observationHtml: `Your ${metricName} increased during this period, and you outpaced ${otherCompaniesName}. Look at you!`
                        };
                    }

                    if (benchmarkAverageDailyGrowthRate > 0 && benchmarkAverageDailyGrowthRate > focusCompanyAverageDailyGrowthRate) {
                        // They increased, and they increased more
                        // Copy: Your engagement increased during this period! However, your rate of increase was lower than [company name'syour average competitor's/your landscape's].
                        return {
                            observationIconClass: 'fa-thumbs-up',
                            observationHtml: `Your ${metricName} increased during this period! However, your rate of increase was lower than ${otherCompaniesNamePossessive}.`
                        };
                    }

                    // They decreased or didn't change
                    // Copy: Your engagement increased during this period, and you outpaced [company name/your average competitor/your landscape]. Outstanding!
                    return {
                        observationIconClass: 'fa-thumbs-up',
                        observationHtml: `Your ${metricName} increased during this period, and you outpaced ${otherCompaniesName}. Outstanding!`
                    };
                } else if (focusCompanyAverageDailyGrowthRate === 0) {
                    // You didn't change

                    if (benchmarkAverageDailyGrowthRate > 0) {
                        // They increased
                        // Copy: Although you maintained your total engagement, [company name/your average competitor/your landscape] increased during this period.

                        return {
                            observationIconClass: 'fa-flag',
                            observationHtml: `Although you maintained your ${metricName}, ${otherCompaniesName} increased during this period.`
                        };
                    }

                    if (benchmarkAverageDailyGrowthRate === 0) {
                        // They didn’t change
                        // Copy: You maintained your total engagement during this period, right along with [company name/your average competitor/your landscape].

                        return {
                            observationIconClass: 'fa-flag',
                            observationHtml: `You maintained your ${metricName} during this period, right along with ${otherCompaniesName}.`
                        };
                    }

                    // They decreased
                    // Copy: You maintained your total engagement during this period, while [company name/your average competitor/your landscape] saw a decrease. Good for you!

                    return {
                        observationIconClass: 'fa-thumbs-up',
                        observationHtml: `You maintained your ${metricName} during this period, while ${otherCompaniesName} saw a decrease. Good for you!`
                    };
                } else {
                    // You decreased

                    // First sentence
                    // Copy: Your total engagement decreased during this period.
                    secondSentence = decreasedValueExplainerSentence(dashboardModel, observationMetrics);
                    // if there's no explainer sentence, include how much the views decreased
                    if (metricProperty === 'views' && !secondSentence) {
                        firstSentence = `Your ${metricName} decreased by ${focusCompanyPercentChangedFormatted} during this period.`;
                    } else {
                        firstSentence = `Your ${metricName} decreased during this period.`;
                    }

                    return {
                        observationIconClass: 'fa-lightbulb-o',
                        observationHtml: _.compact([firstSentence, secondSentence]).join(' ')
                    };
                }
            }
        } else {
            // Only the focus company had data, just comment on it.
            if (focusCompanyAverageDailyGrowthRate > 0) {

                if (metricProperty === 'presence_reach') {
                    // Copy (audience): Company’s Facebook Page Fans grew by 20%. Nice work!
                    return {
                        observationIconClass: 'fa-thumbs-up',
                        observationHtml: `${companyLink(focusCompany, true)} ${metricName(focusCompanyMainPeriod)} grew by ${focusCompanyPercentChangedFormatted}. ${randomPositiveStatement()}`
                    };
                } else if (metricProperty === 'engagement_total' || metricProperty === 'views') {
                    // Copy (engagement): Company’s Facebook engagement increased 20% during this period. {positive statement}
                    return {
                        observationIconClass: 'fa-thumbs-up',
                        observationHtml: `${companyLink(focusCompany, true)} ${metricName(focusCompanyMainPeriod)} increased ${focusCompanyPercentChangedFormatted} during this period. ${randomPositiveStatement()}`
                    };
                } else if (metricProperty === 'avg_engagement_rate_per_post' || metricProperty === 'engagement_total_per_view') {
                    // Copy (engagement rate): Company’s Facebook Engagement Rate by Follower increased by 20%.
                    return {
                        observationIconClass: 'fa-thumbs-up',
                        observationHtml: `${companyLink(focusCompany, true)} ${metricName(focusCompanyMainPeriod)} increased by ${focusCompanyPercentChangedFormatted}.`
                    };
                }

            } else if (focusCompanyAverageDailyGrowthRate === 0) {

                if (metricProperty === 'presence_reach') {
                    // Copy (audience): Company’s Facebook Page Fans were consistent during this period. Keep posting  high-engagement content to attract new page fans.
                    return {
                        observationIconClass: 'fa-flag',
                        observationHtml: `${companyLink(focusCompany, true)} ${metricName(focusCompanyMainPeriod)} were consistent during this period. Keep posting  high-engagement content to attract new ${focusCompanyMainPeriod.getName().toLowerCase()}.`
                    };
                } else if (metricProperty === 'engagement_total' || metricProperty === 'views') {
                    // Copy (engagement): Company’s Facebook engagement was consistent during this period. Keep posting high-engagement content you know your audience will love.
                    return {
                        observationIconClass: 'fa-flag',
                        observationHtml: `${companyLink(focusCompany, true)} ${metricName(focusCompanyMainPeriod)} was consistent during this period. Keep posting high-engagement content you know your audience will love.`
                    };
                } else if (metricProperty === 'avg_engagement_rate_per_post' || metricProperty === 'engagement_total_per_view') {
                    // Copy (engagement rate): Company’s Facebook Engagement Rate by Follower was consistent during this.
                    return {
                        observationIconClass: 'fa-flag',
                        observationHtml: `${companyLink(focusCompany, true)} ${metricName(focusCompanyMainPeriod)}  was consistent during this period.`
                    };
                }
            } else if (_.isFinite(focusCompanyAverageDailyGrowthRate)) {

                if (metricProperty === 'presence_reach') {
                    // Copy (audience): Company’s Facebook Page Fans shrunk by 20%. Get back into growth mode by creating and sharing content your fans can’t help but engage with.
                    return {
                        observationIconClass: 'fa-flag',
                        observationHtml: `${companyLink(focusCompany, true)} ${metricName(focusCompanyMainPeriod)} shrunk by ${focusCompanyPercentChangedFormatted}. Get back into growth mode by creating and sharing content your fans can’t help but engage with.`
                    };
                } else if (metricProperty === 'engagement_total' || metricProperty === 'views') {
                    // Copy (engagement): Company’s Facebook engagement decreased 20% during this period.
                    return {
                        observationIconClass: 'fa-flag',
                        observationHtml: `${companyLink(focusCompany, true)} ${metricName(focusCompanyMainPeriod)} shrunk by ${focusCompanyPercentChangedFormatted} during this period.`
                    };
                } else if (metricProperty === 'avg_engagement_rate_per_post' || metricProperty === 'engagement_total_per_view') {
                    // Copy (engagement rate): Company’s Facebook Engagement Rate by Follower decreased by 20%.
                    return {
                        observationIconClass: 'fa-flag',
                        observationHtml: `${companyLink(focusCompany, true)} ${metricName(focusCompanyMainPeriod)}  decreased by ${focusCompanyPercentChangedFormatted}.`
                    };
                }
            } else {
                const focusCompanyMainPeriodValueFormatted = focusCompanyMainPeriod.getValue();
                if (metricProperty === 'presence_reach') {
                    // Copy (audience): Company ended this period with 900 Facebook Page Fans.
                    return {
                        observationIconClass: 'fa-flag',
                        observationHtml: `${companyLink(focusCompany)} ended this period with ${focusCompanyMainPeriodValueFormatted} ${metricName(focusCompanyMainPeriod)}.`
                    };
                } else if (metricProperty === 'engagement_total' || metricProperty === 'views') {
                    // Copy (engagement): Company earned 900 total Facebook engagements this period.
                    return {
                        observationIconClass: 'fa-flag',
                        observationHtml: `${companyLink(focusCompany)} earned ${focusCompanyMainPeriodValueFormatted} ${metricName(focusCompanyMainPeriod)} this period.`
                    };
                } else if (metricProperty === 'avg_engagement_rate_per_post' || metricProperty === 'engagement_total_per_view') {
                    // Copy (engagement rate): Company earned a 3.5% Facebook Engagement Rate by Follower this period.
                    return {
                        observationIconClass: 'fa-flag',
                        observationHtml: `${companyLink(focusCompany)} earned a ${focusCompanyPercentChangedFormatted} ${metricName(focusCompanyMainPeriod)}  this period.`
                    };
                }
            }
        }
    };

    data._generateCrossChannelMissingObservation = function (dashboardModel, observationMetrics) {

        if (isSingleChannel(dashboardModel.getProps())) {
            // not cross-channel
            return;
        }

        const focusCompanyMainPeriodValue = getSingleMetricValue(observationMetrics, OBSERVATION_METRICS.FocusCompanyMainPeriod);
        if (_.isNull(focusCompanyMainPeriodValue)) {
            const primaryMetric = observationMetrics[OBSERVATION_METRICS.FocusCompanyMainPeriod];
            const dateKey = (primaryMetric.get('property') === 'audience' ? 'earliestPresenceData' : 'earliestPostData');
            const focusCompanyId = dashboardModel.getProp('focusCompanyId');
            const focusCompany = RivalIQ.state.landscape.getCompanyById(focusCompanyId);
            const date = _.get(RivalIQ.utils.incompleteData.getLatestDate(RivalIQ.enums.sources.CROSS_CHANNEL, focusCompany.attributes, dateKey), ['date']);

            if (date && moment.utc(date).isAfter(primaryMetric.get('timePeriod').mainPeriodStart)) {
                return {
                    observationIconClass: 'fa-warning',
                    observationHtml: 'Nothing remarkable to show you right now.'
                };
            }
        }
    };

    // Question: [Audience, Engagement] Do you fall above or below the competitive average?
    // This is cross-channel 1a in the spec.
    data._generateCrossChannelCompetitiveObservation = function (dashboardModel, observationMetrics) {

        if (isSingleChannel(dashboardModel.getProps())) {
            // not cross-channel
            return;
        }

        const focusCompanyMainPeriod = observationMetrics[OBSERVATION_METRICS.FocusCompanyMainPeriod];
        const metricProperty = focusCompanyMainPeriod.get('property');

        if (!_.includes(CrossChannelCompetitiveMetrics, metricProperty)) {
            return;
        }

        const noDataObservation = data._generateCrossChannelMissingObservation(dashboardModel, observationMetrics);
        if (noDataObservation) {
            return noDataObservation;
        }

        const focusCompanyId = dashboardModel.getProp('focusCompanyId');
        const focusCompany = RivalIQ.state.landscape.getCompanyById(focusCompanyId);
        const dataByCompany = getDataByFreeDimension(observationMetrics, OBSERVATION_METRICS.ByCompany);
        const focusCompanyMainPeriodValue = getSingleMetricValue(observationMetrics, OBSERVATION_METRICS.FocusCompanyMainPeriod);

        const focusCompanyMainPeriodPostsPerDay = getSingleMetricValue(observationMetrics, OBSERVATION_METRICS.FocusCompanyPostsPerDay);
        if (metricProperty === 'engagement_total' && focusCompanyMainPeriodPostsPerDay > 0 && focusCompanyMainPeriodValue === 0) {
            // [Company published posts in period but got no engagement on their posts]

            if (focusCompanyMainPeriod.get('property') === 'avg_engagement_rate_per_post') {
                return;
            }

            // Company received 0 total engagements. Continue experimenting with your content - you can do it!
            return {
                observationIconClass: 'fa-lightbulb-o',
                observationHtml: `${companyLink(focusCompany)} received 0 total engagements. Continue experimenting with your content - you can do it!`
            };
        }

        if (focusCompanyMainPeriodValue === 0 && metricProperty === 'engagement_total') {
            const firstSentence = `${companyLink(focusCompany)} received 0 total engagements because you didn't post this period.`;
            let secondSentence = '';
            if (getSingleMetricValue(observationMetrics, OBSERVATION_METRICS.BenchmarkAverage) > 0) {
                secondSentence = ` Try to post more to keep up with the ${compareAgainstName(observationMetrics[OBSERVATION_METRICS.BenchmarkAverage])}!`;
            }

            return {
                observationIconClass: 'fa-lightbulb-o',
                observationHtml: firstSentence + secondSentence
            };
        }

        if (dataByCompany.length > 1) {

            // This is the focus company's rank of companies in the current company set filter on this channel (1-based index)
            const focusCompanyRank = _.findIndex(dataByCompany, function (value) {
                return value[0] === focusCompanyId;
            }) + 1;
            let encouragementPhrase = '';

            if (focusCompanyRank === 1) {
                // Company ranks 1st of 84 companies for Audience. Good job!
                // Company ranks 1st of 84 companies for Engagement Total. Way to go!

                if (metricProperty === 'audience') {
                    encouragementPhrase = ' Good job!';
                } else {
                    encouragementPhrase = ' Way to go!';
                }
                return {
                    observationIconClass: 'fa-trophy',
                    observationHtml: `${companyLink(focusCompany)} ranks 1st of ${dataByCompany.length} companies for ${metricName(focusCompanyMainPeriod)}.${encouragementPhrase}`
                };
            } else {
                const average = getSingleMetricValue(observationMetrics, OBSERVATION_METRICS.BenchmarkAverage);

                // If the average is not finite, fall through to the 1 company observations.
                if (_.isFinite(average)) {

                    switch (relationToRange(focusCompanyMainPeriodValue, average)) {
                        case ABOVE_RANGE: {
                            // Company is above average for Audience, ranking 2nd of 84 companies. Nice work!
                            // Company is above average for Engagement Total, ranking 2nd of 84 companies. Keep up the good work!

                            if (metricProperty === 'audience') {
                                encouragementPhrase = ' Nice work!';
                            } else {
                                encouragementPhrase = ' Keep up the good work!';
                            }

                            // Company is above average for Engagement Total, ranking 2nd of 84 companies. Keep it up.
                            return {
                                observationIconClass: 'fa-thumbs-up',
                                observationHtml: `${companyLink(focusCompany)} is above average for ${metricName(focusCompanyMainPeriod)
                                }, ranking ${focusCompanyRank.ordinal()} of ${dataByCompany.length} companies.${encouragementPhrase}`
                            };
                        }

                        case NEAR_RANGE: {
                            // Company is average for Audience, ranking 10th of 84 companies. Keep aiming for the top!
                            // Company is average for Engagement Total, ranking 10th of 84 companies. You’re on the right track!

                            if (metricProperty === 'audience') {
                                encouragementPhrase = ' Keep aiming for the top!';
                            } else {
                                encouragementPhrase = ` You're on the right track!`;
                            }

                            // Company is about average for Engagement Total, ranking 10th of 84 companies. Keep moving up.
                            return {
                                observationIconClass: 'fa-thumbs-up',
                                observationHtml: `${companyLink(focusCompany)} is average for ${metricName(focusCompanyMainPeriod)
                                }, ranking ${focusCompanyRank.ordinal()} of ${dataByCompany.length} companies.${encouragementPhrase}`
                            };
                        }

                        case BELOW_RANGE: {
                            // Company is below average for Audience, ranking 22nd of 84 companies. This is a good place to focus your attention.
                            // Company is below average for Engagement Total, ranking 22nd of 84 companies. This is a good place to focus your attention.

                            return {
                                observationIconClass: 'fa-flag',
                                observationHtml: `${companyLink(focusCompany)} is below average for ${metricName(focusCompanyMainPeriod)
                                }, ranking ${focusCompanyRank.ordinal()} of ${dataByCompany.length} companies. ${attentionGrabStatement(average)}`
                            };
                        }

                        default:
                            // should never happen.
                    }
                }
            }
        }
    };

    // Question: [Activity] Do you fall above or below the competitive average? What’s the posting rate?
    // This is cross-channel 1b in the spec.
    data._generateCrossChannelActivityObservation = function (dashboardModel, observationMetrics) {

        if (isSingleChannel(dashboardModel.getProps())) {
            // not cross-channel
            return;
        }

        const focusCompanyMainPeriod = observationMetrics[OBSERVATION_METRICS.FocusCompanyMainPeriod];
        const metricProperty = focusCompanyMainPeriod.get('property');

        if (!_.includes(CrossChannelActivityMetrics, metricProperty)) {
            return;
        }

        const noDataObservation = data._generateCrossChannelMissingObservation(dashboardModel, observationMetrics);
        if (noDataObservation) {
            return noDataObservation;
        }

        const focusCompanyId = dashboardModel.getProp('focusCompanyId');
        const focusCompany = RivalIQ.state.landscape.getCompanyById(focusCompanyId);
        const dataByCompany = getDataByFreeDimension(observationMetrics, OBSERVATION_METRICS.ByCompany);
        const focusCompanyMainPeriodPostsPerDay = getSingleMetricValue(observationMetrics, OBSERVATION_METRICS.FocusCompanyPostsPerDay);
        const averagePostsPerDay = getSingleMetricValue(observationMetrics, OBSERVATION_METRICS.BenchmarkAveragePostsPerDay);

        if (focusCompanyMainPeriodPostsPerDay === 0) {
            // Company didn't post this period. You should post something — your followers want to hear from you!
            return {
                observationIconClass: 'fa-lightbulb-o',
                observationHtml: `${companyLink(focusCompany)} didn't post this period. You should post something &mdash; your followers want to hear from you!`
            };
        }

        if (dataByCompany.length > 1 && _.isFinite(averagePostsPerDay)) {
            // Multiple companies; if the average is not finite, fall through to the 1 company observations.

            switch (relationToRange(focusCompanyMainPeriodPostsPerDay, averagePostsPerDay)) {
                case ABOVE_RANGE: {
                    //  Company's posting frequency is above average, with about 240 posts per week.
                    return {
                        observationIconClass: 'fa-thumbs-up',
                        observationHtml: `${companyLink(focusCompany, true)} posting frequency is above average, with ${formatPostsPerPeriod(observationMetrics[OBSERVATION_METRICS.FocusCompanyPostsPerDay])}.`
                    };
                }

                case NEAR_RANGE: {
                    // Company's posting frequency is average, with about 240 posts per week.
                    return {
                        observationIconClass: 'fa-thumbs-up',
                        observationHtml: `${companyLink(focusCompany, true)} posting frequency is average, with ${formatPostsPerPeriod(observationMetrics[OBSERVATION_METRICS.FocusCompanyPostsPerDay])}.`
                    };
                }

                case BELOW_RANGE: {
                    // Company's posting frequency is below average, with about 240 posts per week.
                    return {
                        observationIconClass: 'fa-flag',
                        observationHtml: `${companyLink(focusCompany, true)} posting frequency is below average, with ${formatPostsPerPeriod(observationMetrics[OBSERVATION_METRICS.FocusCompanyPostsPerDay])}.`
                    };
                }

                default:
                    // should never happen.
            }
        }

        const focusCompanyComparePeriodPostsPerDay = getSingleMetricValue(observationMetrics, OBSERVATION_METRICS.FocusCompanyComparePeriodPostsPerDay);
        if (_.isFinite(focusCompanyComparePeriodPostsPerDay)) {

            switch (relationToRange(focusCompanyMainPeriodPostsPerDay, focusCompanyComparePeriodPostsPerDay)) {
                case ABOVE_RANGE: {
                    // Company posted more frequently this period, with about 240 posts per week.
                    return {
                        observationIconClass: 'fa-thumbs-up',
                        observationHtml: `${companyLink(focusCompany)} posted more frequently this period, with ${formatPostsPerPeriod(observationMetrics[OBSERVATION_METRICS.FocusCompanyPostsPerDay])}.`
                    };
                }

                case NEAR_RANGE: {
                    // Company posted about the same number of times this period, with about 240 posts per week.
                    const wasExactlyTheSame = (focusCompanyMainPeriodPostsPerDay === focusCompanyComparePeriodPostsPerDay);
                    return {
                        observationIconClass: 'fa-flag',
                        observationHtml: `${companyLink(focusCompany)} posted ${wasExactlyTheSame ? '' : 'about'} the same number of times this period, with ${formatPostsPerPeriod(observationMetrics[OBSERVATION_METRICS.FocusCompanyPostsPerDay])}.`
                    };
                }

                case BELOW_RANGE: {
                    // Company posted less frequently this period, with about 240 posts per week
                    return {
                        observationIconClass: 'fa-flag',
                        observationHtml: `${companyLink(focusCompany)} posted less frequently this period, with ${formatPostsPerPeriod(observationMetrics[OBSERVATION_METRICS.FocusCompanyPostsPerDay])}.`
                    };
                }

                default:
                    // should never happen.
            }
        }

        // Company published 240 posts per week during this period.
        return {
            observationIconClass: 'fa-flag',
            observationHtml: `${companyLink(focusCompany)} published ${formatPostsPerPeriod(observationMetrics[OBSERVATION_METRICS.FocusCompanyPostsPerDay])} during this period.`
        };
    };

    function mostImprovedChannelName(changeByChannel) {
        const mostImprovedChannel = _.get(changeByChannel, [0, 0]);

        if (mostImprovedChannel) {
            return RivalIQ.data.channels.get(mostImprovedChannel).get('name');
        }
    }

    function mostDeclinedChannelName(changeByChannel) {
        const mostDeclinedChannel = _.get(_.last(changeByChannel), [0]);

        if (mostDeclinedChannel) {
            return RivalIQ.data.channels.get(mostDeclinedChannel).get('name');
        }
    }

    // This is Cross-Channel 2a in the document.
    data._generateCrossChannelChangeObservation = function (dashboardModel, observationMetrics) {

        if (isSingleChannel(dashboardModel.getProps())) {
            // not cross-channel
            return;
        }

        const metricProperty = observationMetrics[OBSERVATION_METRICS.FocusCompanyMainPeriod].get('property');
        if (!_.includes(CrossChanneChangeMetrics, metricProperty)) {
            return;
        }

        const focusCompanyMainPeriodValue = getSingleMetricValue(observationMetrics, OBSERVATION_METRICS.FocusCompanyMainPeriod);
        if (focusCompanyMainPeriodValue === 0) {
            return;
        }

        const focusCompanyAbsoluteChangeValue = getSingleMetricValue(observationMetrics, OBSERVATION_METRICS.FocusCompanyAbsoluteChange);
        if (!_.isFinite(focusCompanyAbsoluteChangeValue)) {
            return;
        }

        const dataByCompany = getDataByFreeDimension(observationMetrics, OBSERVATION_METRICS.ByCompany);
        const benchmarkAbsoluteChangeValue = getSingleMetricValue(observationMetrics, OBSERVATION_METRICS.BenchmarkAverageAbsoluteChange);

        const focusCompanyId = dashboardModel.getProp('focusCompanyId');
        const focusCompany = RivalIQ.state.landscape.getCompanyById(focusCompanyId);

        const compareAgainst = _.find(RivalIQ.enums.benchmarkCompareAgainstOptions, {
            benchmarkCompaniesFilter: observationMetrics[OBSERVATION_METRICS.BenchmarkAverageAbsoluteChange].get('benchmarkCompaniesFilter'),
            aggregate: observationMetrics[OBSERVATION_METRICS.BenchmarkAverageAbsoluteChange].get('aggregate')
        });
        const otherCompaniesName = otherCompanyLink(compareAgainst, dashboardModel, false, 'your landscape');

        const focusCompanyAbsoluteChangeByChannel = getDataByFreeDimension(observationMetrics, OBSERVATION_METRICS.FocusCompanyAbsoluteChangeByChannel);
        const benchmarkChangeByChannel = getDataByFreeDimension(observationMetrics, OBSERVATION_METRICS.BenchmarkAverageAbsoluteChangeByChannel);

        const focusCompanyPercentChanged = getSingleMetricValue(observationMetrics, OBSERVATION_METRICS.FocusCompanyPercentChange);
        // Use abs as the words will indicate that this is a negative value.
        const focusCompanyPercentChangedFormatted = RivalIQ.formatter.formats.percentAbsolute(Math.abs(focusCompanyPercentChanged));

        const focusCompanyMostImprovedChannel = mostImprovedChannelName(focusCompanyAbsoluteChangeByChannel);
        const focusCompanyMostDeclinedChannel = mostDeclinedChannelName(focusCompanyAbsoluteChangeByChannel);
        const benchmarkMostImprovedChannel = mostImprovedChannelName(benchmarkChangeByChannel);
        const benchmarkMostDeclinedChannel = mostDeclinedChannelName(benchmarkChangeByChannel);

        let observationSentence;
        if (dataByCompany.length > 1 && focusCompanyMostImprovedChannel && benchmarkMostImprovedChannel) {
            // mutiple companies

            if (focusCompanyAbsoluteChangeValue > 0 && benchmarkAbsoluteChangeValue > 0) {
                // You both grew

                if (focusCompanyMostImprovedChannel === benchmarkMostImprovedChannel) {

                    if (metricProperty === 'audience') {
                        // Both Company and [company name/your average competitor/your landscape] saw the most audience growth on Instagram.
                        observationSentence = `Both ${companyLink(focusCompany)} and ${otherCompaniesName} saw the most audience growth on ${focusCompanyMostImprovedChannel}.`;
                    } else {
                        // Both Company and [company name/your average competitor/your landscape] saw the biggest increase in total engagement on Instagram.
                        observationSentence = `Both ${companyLink(focusCompany)} and ${otherCompaniesName} saw the biggest increase in total engagement on ${focusCompanyMostImprovedChannel}.`;
                    }
                } else {

                    if (metricProperty === 'audience') {
                        //  Company saw the most audience growth on Instagram, while [company name/your average competitor/your landscape] grew the most on YouTube.
                        observationSentence = `${companyLink(focusCompany)} saw the most audience growth on  ${focusCompanyMostImprovedChannel
                        }, while ${otherCompaniesName} grew the most on ${benchmarkMostImprovedChannel}.`;
                    } else {
                        // Company saw the biggest increase in total engagement on Instagram, while [company name/your average competitor/your landscape] increased the most on YouTube.
                        observationSentence = `${companyLink(focusCompany)} saw the biggest increase in total engagement on ${focusCompanyMostImprovedChannel
                        }, while ${otherCompaniesName} increased the most on ${benchmarkMostImprovedChannel}.`;
                    }
                }

                return {
                    observationIconClass: 'fa-thumbs-up',
                    observationHtml: observationSentence
                };
            }

            if (focusCompanyAbsoluteChangeValue > 0 && benchmarkAbsoluteChangeValue < 0) {
                // You grew, they fell

                if (metricProperty === 'audience') {
                    // Company’s audience grew and saw the most growth on Instagram. Good job moving up while [company name/your average competitor/your landscape] fell!
                    observationSentence = `${companyLink(focusCompany, true)} audience grew and saw the most growth on ${focusCompanyMostImprovedChannel}. Good job moving up while ${otherCompaniesName} fell!`;
                } else {
                    // Company's total engagement increased and saw the biggest increase on Instagram. You deserve it!
                    observationSentence = `${companyLink(focusCompany, true)} total engagement increased and saw the biggest increase on ${focusCompanyMostImprovedChannel}. You deserve it!`;
                }

                return {
                    observationIconClass: 'fa-thumbs-up',
                    observationHtml: observationSentence
                };
            }

            if (focusCompanyAbsoluteChangeValue < 0 && benchmarkAbsoluteChangeValue > 0) {
                // You fell, they grew

                if (focusCompanyMostDeclinedChannel === benchmarkMostImprovedChannel) {
                    if (metricProperty === 'audience') {
                        // Company’s audience decreased and saw the biggest loss on Facebook. At the same time, [company name/your average competitor/your landscape] grew and saw the most growth on Facebook.
                        observationSentence = `${companyLink(focusCompany, true)} audience decreased and saw the biggest loss on ${focusCompanyMostDeclinedChannel}. At the same time, ${otherCompaniesName} grew and saw the most growth on ${benchmarkMostImprovedChannel}.`;
                    } else {
                        // Company’s total engagement decreased and saw the biggest drop on Facebook. At the same time, [company name/your average competitor/your landscape] grew and saw the most growth on Facebook.
                        observationSentence = `${companyLink(focusCompany, true)} total engagement decreased and saw the biggest drop on ${focusCompanyMostDeclinedChannel}. At the same time, ${otherCompaniesName} grew and saw the most growth on ${benchmarkMostImprovedChannel}.`;
                    }
                } else {

                    if (metricProperty === 'audience') {
                        // Company’s audience decreased and saw the biggest loss on Facebook. At the same time, [company name/your average competitor/your landscape] grew and saw the most growth on Facebook.
                        observationSentence = `${companyLink(focusCompany, true)} audience decreased and saw the biggest loss on ${focusCompanyMostDeclinedChannel}. At the same time, ${otherCompaniesName} grew and saw the most growth on ${benchmarkMostImprovedChannel}.`;
                    } else {
                        // Company’s total engagement decreased and saw the largest drop on Facebook. At the same time, [company name/your average competitor/your landscape] grew and saw the most growth on Facebook.
                        observationSentence = `${companyLink(focusCompany, true)} total engagement decreased and saw the largest drop on ${focusCompanyMostDeclinedChannel}. At the same time, ${otherCompaniesName} grew and saw the most growth on ${benchmarkMostImprovedChannel}.`;
                    }
                }

                return {
                    observationIconClass: 'fa-flag',
                    observationHtml: observationSentence
                };
            }

            if (focusCompanyAbsoluteChangeValue < 0 && benchmarkAbsoluteChangeValue < 0) {
                // You both fell

                if (focusCompanyMostDeclinedChannel === benchmarkMostDeclinedChannel) {
                    if (metricProperty === 'audience') {
                        // Both Company and [company name/your average competitor/your landscape] lost the most audience on Instagram.
                        observationSentence = `Both ${companyLink(focusCompany)} and ${otherCompaniesName} lost the most audience on ${focusCompanyMostDeclinedChannel}.`;
                    } else {
                        // Both Company and [company name/your average competitor/your landscape] lost the most total engagement on Instagram.
                        observationSentence = `Both ${companyLink(focusCompany)} and ${otherCompaniesName} lost the most total engagement on ${focusCompanyMostDeclinedChannel}.`;
                    }
                } else {

                    if (metricProperty === 'audience') {
                        // Company’s audience decreased the most on Instagram, while [company name/your average competitor/your landscape] decreased the most on YouTube.
                        observationSentence = `${companyLink(focusCompany, true)} audience decreased the most on ${focusCompanyMostDeclinedChannel}, while ${otherCompaniesName} decreased the most on ${benchmarkMostDeclinedChannel}.`;
                    } else {
                        // Company’s total engagement decreased the most on Instagram, while [company name/your average competitor/your landscape] decreased the most on YouTube.
                        observationSentence = `${companyLink(focusCompany, true)} total engagement decreased the most on ${focusCompanyMostDeclinedChannel}, while ${otherCompaniesName} decreased the most on ${benchmarkMostDeclinedChannel}.`;
                    }
                }

                return {
                    observationIconClass: 'fa-flag',
                    observationHtml: observationSentence
                };
            }
        }

        if (focusCompanyAbsoluteChangeValue > 0 && _.isFinite(_.get(focusCompanyAbsoluteChangeByChannel, [0, 1]))) {
            // 1 company, % increased

            if (metricProperty === 'audience') {
                // Company’s audience increased 20% and saw the largest increase on Instagram. Nice work!
                observationSentence = `${companyLink(focusCompany, true)} audience increased ${focusCompanyPercentChangedFormatted} and saw the largest increase on ${focusCompanyMostImprovedChannel}. Nice work!`;
            } else {
                // Company’s total engagement increased 20% and saw the largest increase on Instagram. Nice work!
                observationSentence = `${companyLink(focusCompany, true)} total engagement increased ${focusCompanyPercentChangedFormatted} and saw the largest increase on ${focusCompanyMostImprovedChannel}. Nice work!`;
            }

            return {
                observationIconClass: 'fa-thumbs-up',
                observationHtml: observationSentence
            };
        }

        if (focusCompanyAbsoluteChangeValue === 0) {
            // 1 company, no change
            if (metricProperty === 'audience') {
                // Company’s audience was consistent. Keep working on growing your audience.
                observationSentence = `${companyLink(focusCompany, true)} audience was consistent. Keep working on growing your audience.`;
            } else {
                // Company saw the same total engagement as last period. Continue working toward growing your engagement.
                observationSentence = `${companyLink(focusCompany, true)} saw the same total engagement as last period. Continue working toward growing your engagement.`;
            }

            return {
                observationIconClass: 'fa-thumbs-up',
                observationHtml: observationSentence
            };
        }

        const focusCompanyPercentChangeByChannel = getDataByFreeDimension(observationMetrics, OBSERVATION_METRICS.FocusCompanyPercentChangeByChannel);
        if (focusCompanyAbsoluteChangeValue < 0 && _.isFinite(_.get(_.last(focusCompanyPercentChangeByChannel), [1]))) {
            // 1 company, value decreased
            if (metricProperty === 'audience') {
                // Company’s audience decreased 20% and saw the biggest loss on Instagram.
                observationSentence = `${companyLink(focusCompany, true)} audience decreased ${focusCompanyPercentChangedFormatted} and saw the biggest loss on ${focusCompanyMostDeclinedChannel}.`;
            } else {
                // Company’s total engagement decreased 20% and saw the largest drop on Instagram.
                observationSentence = `${companyLink(focusCompany, true)} total engagement decreased ${focusCompanyPercentChangedFormatted} and saw the largest drop on ${focusCompanyMostDeclinedChannel}.`;
            }

            return {
                observationIconClass: 'fa-flag',
                observationHtml: observationSentence
            };
        }

        const mainPeriodValueFormatted = observationMetrics[OBSERVATION_METRICS.FocusCompanyMainPeriod].getValue();
        if (metricProperty === 'audience') {
            // Company ended this period with a total audience of 900.
            observationSentence = `${companyLink(focusCompany)} ended this period with a total audience of ${mainPeriodValueFormatted}.`;
        } else {
            // Company earned a total of 900 engagements this period.
            observationSentence = `${companyLink(focusCompany)} earned a total of ${mainPeriodValueFormatted} engagements this period.`;
        }

        return {
            observationIconClass: 'fa-flag',
            observationHtml: observationSentence
        };
    };


    function emptyObservation() {
        return {
            observationIconClass: 'fa-warning',
            observationHtml: 'Nothing remarkable to show you right now.'
        };
    }

    // Returns an array of observations. Each observation is an html string.
    data.getLandscapeObservations = function (dashboardModel, observationMetrics) {

        let observations = [
            // single channel
            data._generateSingleChannelCompetitiveObservation(dashboardModel, observationMetrics),
            data._generateSingleChannelActivityObservation(dashboardModel, observationMetrics),
            data._generateSingleChannelChangeObservation(dashboardModel, observationMetrics),

            data._generateTwitterActivityObservation(dashboardModel, observationMetrics),

            // cross-channel
            data._generateCrossChannelCompetitiveObservation(dashboardModel, observationMetrics),
            data._generateCrossChannelActivityObservation(dashboardModel, observationMetrics),
            data._generateCrossChannelChangeObservation(dashboardModel, observationMetrics),
            data._generateAudienceStartedObservations(dashboardModel, observationMetrics)
        ];

        observations = _.compact(observations);

        if (_.isEmpty(observations) && !_.includes(['avg_engagement_rate_per_post', 'engagement_total_per_view'], observationMetrics[OBSERVATION_METRICS.FocusCompanyMainPeriod].get('property'))) {
            observations = [emptyObservation()];
        }

        return observations;
    };
});
